window.FoxTheme = window.FoxTheme || {};
FoxTheme.config = {
  hasLocalStorage: false,
  mqlMobile: false,
  mqlTablet: false,
  mqlLaptop: false,
  mqlSmallDesktop: false,
  mediaQueryMobile: 'screen and (max-width: 767px)',
  mediaQueryTablet: 'screen and (max-width: 1023px)',
  mediaQueryLaptop: 'screen and (max-width: 1279px)',
  mediaQuerySmallDesktop: 'screen and (max-width: 1535px)',
  motionReduced: window.matchMedia('(prefers-reduced-motion: reduce)').matches,
  isTouch: (() => {
    const hasTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
    const hasPointerFine = window.matchMedia('(pointer: fine)').matches;
    return hasTouch && !hasPointerFine;
  })(),
  isRTL: document.documentElement.getAttribute('dir') === 'rtl',
};
console.log(
  '%c' + window.FoxTheme.settings.themeName + ' theme (v' + window.FoxTheme.settings.themeVersion + ') by Foxecom',
  'font-size: 14px; color: #FF5C00;'
);
(function () {
  // Detect browser has support local storage.
  try {
    const key = 'hyper:test';
    window.localStorage.setItem(key, 'test');
    window.localStorage.removeItem(key);
    FoxTheme.config.hasLocalStorage = true;
  } catch (err) {}

  FoxTheme.DOMready = function (callback) {
    document.readyState != 'loading' ? callback() : document.addEventListener('DOMContentLoaded', callback);
  };

  FoxTheme.a11y = {
    trapFocusHandlers: {},
    getFocusableElements: (container) => {
      return Array.from(
        container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
      );
    },
    trapFocus: (container, elementToFocus = container) => {
      var elements = FoxTheme.a11y.getFocusableElements(container);
      var first = elements[0];
      var last = elements[elements.length - 1];

      FoxTheme.a11y.removeTrapFocus();

      FoxTheme.a11y.trapFocusHandlers.focusin = (event) => {
        if (event.target !== container && event.target !== last && event.target !== first) return;

        document.addEventListener('keydown', FoxTheme.a11y.trapFocusHandlers.keydown);
      };

      FoxTheme.a11y.trapFocusHandlers.focusout = function () {
        document.removeEventListener('keydown', FoxTheme.a11y.trapFocusHandlers.keydown);
      };

      FoxTheme.a11y.trapFocusHandlers.keydown = function (event) {
        if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
        // On the last focusable element and tab forward, focus the first element.
        if (event.target === last && !event.shiftKey) {
          event.preventDefault();
          first.focus();
        }

        //  On the first focusable element and tab backward, focus the last element.
        if ((event.target === container || event.target === first) && event.shiftKey) {
          event.preventDefault();
          last.focus();
        }
      };

      document.addEventListener('focusout', FoxTheme.a11y.trapFocusHandlers.focusout);
      document.addEventListener('focusin', FoxTheme.a11y.trapFocusHandlers.focusin);

      elementToFocus.focus();

      if (
        elementToFocus.tagName === 'INPUT' &&
        ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
        elementToFocus.value
      ) {
        elementToFocus.setSelectionRange(0, elementToFocus.value.length);
      }
    },
    removeTrapFocus: (elementToFocus = null) => {
      document.removeEventListener('focusin', FoxTheme.a11y.trapFocusHandlers.focusin);
      document.removeEventListener('focusout', FoxTheme.a11y.trapFocusHandlers.focusout);
      document.removeEventListener('keydown', FoxTheme.a11y.trapFocusHandlers.keydown);

      if (elementToFocus) elementToFocus.focus();
    },
  };

  FoxTheme.utils = {
    // Escapes a string for safe interpolation into HTML, both as text content
    // and inside double/single-quoted attributes. & must be replaced first.
    escapeHtml: (value) =>
      String(value ?? '')
        .replace(/&/g, '&amp;')   // escape '&'
        .replace(/</g, '&lt;')    // escape '<'
        .replace(/>/g, '&gt;')    // escape '>'
        .replace(/"/g, '&quot;')  // escape '"'
        .replace(/'/g, '&#39;'),  // escape '''
    throttle: (callback) => {
      let requestId = null,
        lastArgs;
      const later = (context) => () => {
        requestId = null;
        callback.apply(context, lastArgs);
      };
      const throttled = (...args) => {
        lastArgs = args;
        if (requestId === null) {
          requestId = requestAnimationFrame(later(this));
        }
      };
      throttled.cancel = () => {
        cancelAnimationFrame(requestId);
        requestId = null;
      };
      return throttled;
    },
    setScrollbarWidth: () => {
      const scrollbarWidth = window.innerWidth - document.body.clientWidth;
      scrollbarWidth > 0 && document.documentElement.style.setProperty('--scrollbar-width', `${scrollbarWidth}px`);
    },
    waitForEvent: (element, eventName) => {
      return new Promise((resolve) => {
        // Event handler that checks if the event target is the expected element
        const eventHandler = (event) => {
          if (event.target === element) {
            element.removeEventListener(eventName, eventHandler); // Clean up listener
            resolve(event); // Resolve the promise with the event
          }
        };

        // Attach the event handler to the element
        element.addEventListener(eventName, eventHandler);
      });
    },
    queryDomNodes: (selectors = {}, context = document) => {
      const domNodes = Object.entries(selectors).reduce((acc, [name, selector]) => {
        const findOne = typeof selector === 'string';
        const queryMethod = findOne ? 'querySelector' : 'querySelectorAll';
        const sl = findOne ? selector : selector[0];

        acc[name] = context && context[queryMethod](sl);
        if (!findOne && acc[name]) {
          acc[name] = [...acc[name]];
        }
        return acc;
      }, {});
      return domNodes;
    },
    addEventDelegate: ({ context = document.documentElement, event = 'click', selector, handler, capture = false }) => {
      const listener = function (e) {
        // loop parent nodes from the target to the delegation node
        for (let target = e.target; target && target !== this; target = target.parentNode) {
          if (target.matches(selector)) {
            handler.call(target, e, target);
            break;
          }
        }
      };
      context.addEventListener(event, listener, capture);
      return () => {
        context.removeEventListener(event, listener, capture);
      };
    },
    getSectionId: (element) => {
      if (element.hasAttribute('data-section-id')) {
        return element.dataset.sectionId;
      } else {
        if (!element.classList.contains('shopify-section')) {
          element = element.closest('.shopify-section');
        }
        return element.id.replace('shopify-section-', '');
      }
    },
    debounce: (fn, wait) => {
      let t;
      return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
      };
    },
    fetchConfig: (type = 'json', method = 'POST') => {
      return {
        method,
        headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
      };
    },
    /**
     * Store key-value pair with expiration time in localStorage
     * Use storage instead of cookie to make it work properly on Safari IOS (in iframe).
     */
    setStorage(key, value, expiryInDays = null) {
      if (!FoxTheme.config.hasLocalStorage) return;

      const item = {
        value: value,
      };

      if (expiryInDays !== null) {
        const now = new Date();
        item.expiry = now.getTime() + expiryInDays * 86400000;
      }

      window.localStorage.setItem(key, JSON.stringify(item));
    },
    getStorage(key) {
      if (!FoxTheme.config.hasLocalStorage) return null;

      const itemStr = window.localStorage.getItem(key);
      // If the item doesn't exist, return null.
      if (!itemStr) {
        return null;
      }
      const item = JSON.parse(itemStr);
      // Compare the expiry time of the item with the current time.
      if (item.expiry && new Date().getTime() > item.expiry) {
        // If the item has expired, remove it from storage and return null.
        window.localStorage.removeItem(key);
        return null;
      }
      return item.value;
    },
    postLink: (path, options) => {
      options = options || {};
      const method = options['method'] || 'post';
      const params = options['parameters'] || {};

      const form = document.createElement('form');
      form.setAttribute('method', method);
      form.setAttribute('action', path);

      for (const key in params) {
        for (const index in params[key]) {
          for (const key2 in params[key][index]) {
            const hiddenField = document.createElement('input');
            hiddenField.setAttribute('type', 'hidden');
            hiddenField.setAttribute('name', `${key}[${index}][${key2}]`);
            hiddenField.setAttribute('value', params[key][index][key2]);
            form.appendChild(hiddenField);
          }
        }
      }
      document.body.appendChild(form);
      form.submit();
      document.body.removeChild(form);
    },
    imageReady: (imageOrArray) => {
      if (!imageOrArray) {
        return Promise.resolve();
      }
      imageOrArray = imageOrArray instanceof Element ? [imageOrArray] : Array.from(imageOrArray);
      return Promise.all(
        imageOrArray.map((image) => {
          return new Promise((resolve) => {
            if ((image.tagName === 'IMG' && image.complete) || !image.offsetParent) {
              resolve();
            } else {
              image.onload = () => resolve();
            }
          });
        })
      );
    },
    displayedMedia: (media) => {
      return Array.from(media).find((item) => {
        const style = window.getComputedStyle(item);
        return style.display !== 'none';
      });
    },
  };

  FoxTheme.pubsub = {
    PUB_SUB_EVENTS: {
      cartUpdate: 'cart-update',
      quantityUpdate: 'quantity-update',
      quantityRules: 'quantity-rules',
      quantityBoundries: 'quantity-boundries',
      variantChange: 'variant-change',
      cartError: 'cart-error',
      facetUpdate: 'facet-update',
      optionValueSelectionChange: 'option-value-selection-change',
    },
    subscribers: {},
    subscribe: (eventName, callback) => {
      if (FoxTheme.pubsub.subscribers[eventName] === undefined) {
        FoxTheme.pubsub.subscribers[eventName] = [];
      }

      FoxTheme.pubsub.subscribers[eventName] = [...FoxTheme.pubsub.subscribers[eventName], callback];

      return function unsubscribe() {
        FoxTheme.pubsub.subscribers[eventName] = FoxTheme.pubsub.subscribers[eventName].filter((cb) => {
          return cb !== callback;
        });
      };
    },

    publish: (eventName, data) => {
      if (FoxTheme.pubsub.subscribers[eventName]) {
        FoxTheme.pubsub.subscribers[eventName].forEach((callback) => {
          callback(data);
        });
      }
    },
  };

  FoxTheme.focusVisiblePolyfill = function () {
    const navKeys = [
      'ARROWUP',
      'ARROWDOWN',
      'ARROWLEFT',
      'ARROWRIGHT',
      'TAB',
      'ENTER',
      'SPACE',
      'ESCAPE',
      'HOME',
      'END',
      'PAGEUP',
      'PAGEDOWN',
    ];
    let currentFocusedElement = null;
    let mouseClick = null;

    window.addEventListener('keydown', (event) => {
      if (navKeys.includes(event.code.toUpperCase())) {
        mouseClick = false;
      }
    });

    window.addEventListener('mousedown', (event) => {
      mouseClick = true;
    });

    window.addEventListener(
      'focus',
      () => {
        if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

        if (mouseClick) return;

        currentFocusedElement = document.activeElement;
        currentFocusedElement.classList.add('focused');
      },
      true
    );
  };

  FoxTheme.Carousel = (function () {
    class Carousel {
      constructor(container, options, modules = null) {
        this.container = container;
        let defaultModules = [FoxTheme.Swiper.Navigation, FoxTheme.Swiper.Pagination, FoxTheme.Swiper.A11y];
        if (modules) {
          defaultModules = defaultModules.concat(modules);
        }
        this.options = {
          modules: defaultModules,
          ...options,
        };
      }

      init() {
        this.slider = new FoxTheme.Swiper.Swiper(this.container, this.options);
      }
    }
    return Carousel;
  })();

  FoxTheme.delayUntilInteraction = (function () {
    class ScriptLoader {
      constructor(callback, delay = 5000) {
        this.loadScriptTimer = setTimeout(callback, delay);
        this.userInteractionEvents = [
          'mouseover',
          'mousemove',
          'keydown',
          'touchstart',
          'touchend',
          'touchmove',
          'wheel',
        ];

        this.onScriptLoader = this.triggerScriptLoader.bind(this, callback);
        this.userInteractionEvents.forEach((event) => {
          window.addEventListener(event, this.onScriptLoader, {
            passive: !0,
          });
        });
      }

      triggerScriptLoader(callback) {
        callback();
        clearTimeout(this.loadScriptTimer);
        this.userInteractionEvents.forEach((event) => {
          window.removeEventListener(event, this.onScriptLoader, {
            passive: !0,
          });
        });
      }
    }

    return ScriptLoader;
  })();

  FoxTheme.Currency = (function () {
    const moneyFormat = '${{amount}}'; // eslint-disable-line camelcase

    function formatMoney(cents, format) {
      if (typeof cents === 'string') {
        cents = cents.replace('.', '');
      }
      let value = '';
      const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      const formatString = format || moneyFormat;

      function formatWithDelimiters(number, precision, thousands, decimal) {
        thousands = thousands || ',';
        decimal = decimal || '.';

        if (isNaN(number) || number === null) {
          return 0;
        }

        number = (number / 100.0).toFixed(precision);

        const parts = number.split('.');
        const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        const centsAmount = parts[1] ? decimal + parts[1] : '';

        return dollarsAmount + centsAmount;
      }

      switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
        case 'amount_no_decimals_with_space_separator':
          value = formatWithDelimiters(cents, 0, ' ');
          break;
        case 'amount_with_apostrophe_separator':
          value = formatWithDelimiters(cents, 2, "'");
          break;
      }

      return formatString.replace(placeholderRegex, value);
    }

    function getBaseUnit(variant) {
      if (!variant) {
        return;
      }

      if (!variant.unit_price_measurement || !variant.unit_price_measurement.reference_value) {
        return;
      }

      return variant.unit_price_measurement.reference_value === 1
        ? variant.unit_price_measurement.reference_unit
        : variant.unit_price_measurement.reference_value + variant.unit_price_measurement.reference_unit;
    }

    return {
      formatMoney: formatMoney,
      getBaseUnit: getBaseUnit,
    };
  })();

  new FoxTheme.delayUntilInteraction(() => {
    document.body.removeAttribute('data-initializing');
  });

  FoxTheme.DOMready(FoxTheme.utils.setScrollbarWidth);
  // window.addEventListener('resize', FoxTheme.utils.throttle(FoxTheme.utils.setScrollbarWidth));

  const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
  FoxTheme.config.mqlMobile = mql.matches;
  mql.onchange = (event) => {
    if (event.matches) {
      FoxTheme.config.mqlMobile = true;
      document.dispatchEvent(new CustomEvent('matchMobile'));
    } else {
      FoxTheme.config.mqlMobile = false;
      document.dispatchEvent(new CustomEvent('unmatchMobile'));
    }
  };

  const mqlTablet = window.matchMedia(FoxTheme.config.mediaQueryTablet);
  FoxTheme.config.mqlTablet = mqlTablet.matches;
  mqlTablet.onchange = (event) => {
    if (event.matches) {
      FoxTheme.config.mqlTablet = true;
      document.dispatchEvent(new CustomEvent('matchTablet'));
    } else {
      FoxTheme.config.mqlTablet = false;
      document.dispatchEvent(new CustomEvent('unmatchTablet'));
    }
  };

  const mqlLaptop = window.matchMedia(FoxTheme.config.mediaQueryLaptop);
  FoxTheme.config.mqlLaptop = mqlLaptop.matches;
  mqlLaptop.onchange = (event) => {
    if (event.matches) {
      FoxTheme.config.mqlLaptop = true;
      document.dispatchEvent(new CustomEvent('matchLaptop'));
    } else {
      FoxTheme.config.mqlLaptop = false;
      document.dispatchEvent(new CustomEvent('unmatchLaptop'));
    }
  };

  const mqlSmallDesktop = window.matchMedia(FoxTheme.config.mediaQuerySmallDesktop);
  FoxTheme.config.mqlSmallDesktop = mqlSmallDesktop.matches;
  mqlSmallDesktop.onchange = (event) => {
    if (event.matches) {
      FoxTheme.config.mqlSmallDesktop = true;
      document.dispatchEvent(new CustomEvent('matchSmallDesktop'));
    } else {
      FoxTheme.config.mqlSmallDesktop = false;
      document.dispatchEvent(new CustomEvent('unmatchSmallDesktop'));
    }
  };
})();

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  FoxTheme.focusVisiblePolyfill();
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

class HTMLUpdateUtility {
  /**
   * Used to swap an HTML node with a new node.
   * The new node is inserted as a previous sibling to the old node, the old node is hidden, and then the old node is removed.
   *
   * The function currently uses a double buffer approach, but this should be replaced by a view transition once it is more widely supported https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API
   */
  static viewTransition(oldNode, newContent, preProcessCallbacks = [], postProcessCallbacks = []) {
    if (!oldNode || !newContent) return;
    preProcessCallbacks?.forEach((callback) => callback(newContent));

    const newNodeWrapper = document.createElement('div');
    HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML);
    const newNode = newNodeWrapper.firstChild;

    // dedupe IDs
    const uniqueKey = Date.now();
    oldNode.querySelectorAll('[id], [form]').forEach((element) => {
      element.id && (element.id = `${element.id}-${uniqueKey}`);
      element.form && element.setAttribute('form', `${element.form.getAttribute('id')}-${uniqueKey}`);
    });

    oldNode.parentNode.insertBefore(newNode, oldNode);
    oldNode.style.display = 'none';

    postProcessCallbacks?.forEach((callback) => callback(newNode));

    setTimeout(() => oldNode.remove(), 500);
  }

  // Sets inner HTML and reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
  static setInnerHTML(element, html) {
    element.innerHTML = html;
    element.querySelectorAll('script').forEach((oldScriptTag) => {
      const newScriptTag = document.createElement('script');
      Array.from(oldScriptTag.attributes).forEach((attribute) => {
        newScriptTag.setAttribute(attribute.name, attribute.value);
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }
}
class PageTransition extends HTMLElement {
  constructor() {
    super();

    window.addEventListener('beforeunload', () => {
      document.body.classList.add('page-loading');
    });

    window.addEventListener('DOMContentLoaded', () => {
      FoxTheme.Motion.animate(this, { visibility: 'hidden', opacity: 0 }, { duration: 1 });

      document.body.classList.add('page-loaded');
      document.dispatchEvent(new CustomEvent('page:loaded'));
    });

    window.addEventListener('pageshow', (event) => {
      if (event.persisted) {
        document.body.classList.remove('page-loading');
      }
    });
  }
}
customElements.define('page-transition', PageTransition);

const clearModalComponentCount = new WeakMap();
class ModalComponent extends HTMLElement {
  constructor() {
    super();
    this.events = {
      handleAfterHide: 'modal:handleAfterHide',
      handleAfterShow: 'modal:handleAfterShow',
    };

    this.classes = {
      show: 'modal-show',
      showing: 'modal-showing',
    };
  }

  static get observedAttributes() {
    return ['id', 'open'];
  }

  get isLockingNeeded() {
    return false;
  }

  get requiresBodyAppended() {
    return false;
  }

  get controls() {
    return Array.from(document.querySelectorAll(`[aria-controls="${this.id}"]`));
  }

  get designMode() {
    return this.hasAttribute('shopify-design-mode');
  }

  get open() {
    return this.hasAttribute('open');
  }

  get overlay() {
    return (this._overlay = this._overlay || this.querySelector('.fixed-overlay'));
  }

  get focusElement() {
    const button = this.querySelector('button');
    if (button) return button;

    const focusableElements = FoxTheme.a11y.getFocusableElements(this);
    return focusableElements[0] || this;
  }

  connectedCallback() {
    // Initialize the AbortController
    this.abortController = new AbortController();

    // Add click event listeners to all controls
    this.controls.forEach((button) => {
      button.addEventListener('click', this.onButtonClick.bind(this), {
        signal: this.abortController.signal,
      });
    });

    // Add keyup event listener to document for handling the Escape key
    document.addEventListener('keyup', (event) => event.code === 'Escape' && this.hide(), {
      signal: this.abortController.signal,
    });

    // Additional setup for Shopify design mode
    if (this.designMode && Shopify.designMode) {
      const section = this.closest('.shopify-section');
      section.addEventListener('shopify:section:select', (event) => this.show(null, !event.detail.load), {
        signal: this.abortController.signal,
      });
      section.addEventListener('shopify:section:deselect', this.hide.bind(this), {
        signal: this.abortController.signal,
      });
    }
  }

  disconnectedCallback() {
    this.abortController?.abort();
    Shopify.designMode && document.body.classList.remove(this.classes.show);
  }

  attributeChangedCallback(name, oldValue, newValue) {
    switch (name) {
      case 'open':
        this.controls.forEach((button) => button.setAttribute('aria-expanded', newValue === null ? 'false' : 'true'));

        if (oldValue === null && (newValue === '' || newValue === 'immediate')) {
          this.hidden = false;
          this.removeAttribute('inert');

          this.parentElementBeforeAppend = null;
          if (this.requiresBodyAppended && this.parentElement !== document.body) {
            this.parentElementBeforeAppend = this.parentElement;
            document.body.append(this);
          }
          const handleShowTransitionPromise = this.handleShowTransition(newValue !== 'immediate') || Promise.resolve();
          handleShowTransitionPromise.then(() => {
            this.handleAfterShow();
            this.dispatchEvent(new CustomEvent(this.events.handleAfterShow, { bubbles: true }));
          });
        } else if (oldValue !== null && newValue === null) {
          this.setAttribute('inert', '');

          const handleHideTransitionPromise = this.handleHideTransition() || Promise.resolve();
          handleHideTransitionPromise.then(() => {
            this.handleAfterHide();

            if (!this.hasAttribute('inert')) return;
            if (this.parentElement === document.body && this.parentElementBeforeAppend) {
              this.parentElementBeforeAppend.appendChild(this);
              this.parentElementBeforeAppend = null;
            }
            this.dispatchEvent(new CustomEvent(this.events.handleAfterHide, { bubbles: true }));
            this.hidden = true;
          });
        }
        this.dispatchEvent(new CustomEvent('toggle', { bubbles: true }));

        break;
    }
  }

  onButtonClick(event) {
    event.preventDefault();

    if (this.open) {
      this.hide();
    } else {
      this.show(event.currentTarget);
    }
  }

  hide() {
    if (!this.open) return;
    this.prepareToHide();
    this.removeAttribute('open');

    return FoxTheme.utils.waitForEvent(this, this.events.handleAfterHide);
  }

  show(activeElement = null, animate = true) {
    if (this.open) return;
    this.prepareToShow();
    this.activeElement = activeElement;
    this.setAttribute('open', animate ? '' : 'immediate');

    if (this.isLockingNeeded) {
      document.body.classList.add(this.classes.showing);
    }

    return FoxTheme.utils.waitForEvent(this, this.events.handleAfterShow);
  }

  handleAfterHide() {
    setTimeout(() => {
      FoxTheme.a11y.removeTrapFocus(this.activeElement);
      if (this.isLockingNeeded) {
        const currentModalCount = clearModalComponentCount.get(ModalComponent) - 1;
        clearModalComponentCount.set(ModalComponent, currentModalCount);
        document.body.classList.toggle(this.classes.show, currentModalCount > 0);
      }
    });
  }

  handleAfterShow() {
    FoxTheme.a11y.trapFocus(this, this.focusElement);
    if (this.isLockingNeeded) {
      const currentModalCount = clearModalComponentCount.get(ModalComponent) + 1;
      clearModalComponentCount.set(ModalComponent, currentModalCount);

      // Manage class changes on the document body
      document.body.classList.remove(this.classes.showing);
      document.body.classList.add(this.classes.show);
    }
  }

  prepareToShow() {}

  prepareToHide() {}

  handleShowTransition() {
    setTimeout(() => {
      this.setAttribute('active', '');
    }, 100);

    return new Promise((resolve) => {
      this.overlay.addEventListener(
        'transitionend',
        () => {
          resolve();
        },
        { once: true }
      );
    });
  }

  handleHideTransition() {
    this.removeAttribute('active');

    return new Promise((resolve) => {
      this.overlay.addEventListener(
        'transitionend',
        () => {
          resolve();
        },
        { once: true }
      );
    });
  }
}
customElements.define('modal-component', ModalComponent);
clearModalComponentCount.set(ModalComponent, 0);

class BasicModal extends ModalComponent {
  constructor() {
    super();
  }

  get isLockingNeeded() {
    return true;
  }

  get requiresBodyAppended() {
    return true;
  }
}
customElements.define('basic-modal', BasicModal);

class DrawerComponent extends ModalComponent {
  constructor() {
    super();
    this.events = {
      handleAfterHide: 'drawer:handleAfterHide',
      handleAfterShow: 'drawer:handleAfterShow',
    };
  }
  get isLockingNeeded() {
    return true;
  }
  get requiresBodyAppended() {
    return true;
  }
}
customElements.define('drawer-component', DrawerComponent);

class SpotlightPick extends DrawerComponent {
  constructor() {
    super();
  }

  get requiresBodyAppended() {
    return false;
  }

  get toggleButton() {
    return this.controls.find((control) => control.hasAttribute('data-toggle-spotlight'));
  }

  connectedCallback() {
    super.connectedCallback();

    if (this.toggleButton) {
      this.toggleTeaser(this.toggleButton, false, 0);
    }
  }

  onButtonClick(event) {
    event.preventDefault();
    const { target, currentTarget } = event;
    if (target.hasAttribute('data-close-teaser')) {
      this.toggleTeaser(this.toggleButton, true);
      return;
    }

    super.onButtonClick(event);
  }

  toggleTeaser(toggleEl, shouldHide, hideDurationHours = 4) {
    const currentTime = new Date().getTime();
    const hideDuration = hideDurationHours * 60 * 60 * 1000;

    if (shouldHide) {
      toggleEl.classList.add('hidden');
      localStorage.setItem('spotlight:teaserHidden', 'true');
      localStorage.setItem('spotlight:teaserHideTime', currentTime);
      localStorage.setItem('spotlight:teaserHideDuration', hideDuration);
    } else {
      const teaserHidden = localStorage.getItem('spotlight:teaserHidden');
      const teaserHideTime = localStorage.getItem('spotlight:teaserHideTime');
      const teaserHideDuration = localStorage.getItem('spotlight:teaserHideDuration');

      if (teaserHidden === 'true' && teaserHideTime) {
        const timeElapsed = currentTime - parseInt(teaserHideTime);

        if (timeElapsed < parseInt(teaserHideDuration)) {
          toggleEl.classList.add('hidden');
        } else {
          localStorage.removeItem('spotlight:teaserHidden');
          localStorage.removeItem('spotlight:teaserHideTime');
          localStorage.removeItem('spotlight:teaserHideDuration');
          toggleEl.classList.remove('hidden');
        }
      } else {
        toggleEl.classList.remove('hidden');
      }
    }
  }
}
customElements.define('spotlight-pick', SpotlightPick);

class AccordionDetails extends HTMLDetailsElement {
  constructor() {
    super();
    this.initAccordion();
  }

  initAccordion() {
    this.isOpen = this.hasAttribute('open');
    this.summaryElement = this.querySelector('summary');
    this.contentElement = this.querySelector('summary + *');
    this.setAttribute('aria-expanded', this.isOpen ? 'true' : 'false');

    this.summaryElement.addEventListener('click', this.toggleAccordion.bind(this));

    if (Shopify.designMode) {
      this.designModeEventSetup();
    }
  }

  static get observedAttributes() {
    return ['open'];
  }

  get open() {
    return this.isOpen;
  }

  set open(value) {
    if (value !== this.isOpen) {
      this.isOpen = value;

      if (this.isConnected) {
        this.animateAccordion(value);
      } else {
        if (value) {
          this.setAttribute('open', '');
        } else {
          this.removeAttribute('open');
        }
      }

      this.setAttribute('aria-expanded', value ? 'true' : 'false');
      this.setAttribute('aria-controls', this.contentElement.id);

      this.handleAfterToggle();
    }
  }

  handleAfterToggle() {}

  toggleAccordion(event) {
    event.preventDefault();
    this.open = !this.open;
  }

  close() {
    this.isOpen = false;
    this.animateAccordion(false);
  }

  async animateAccordion(isOpen) {
    this.style.overflow = 'hidden';

    if (isOpen) {
      this.setAttribute('open', '');
      this.parentElement.classList.add('active');

      await FoxTheme.Motion.timeline([
        [
          this,
          { height: [`${this.summaryElement.clientHeight + 1}px`, `${this.scrollHeight + 1}px`] },
          { duration: 0.25, easing: 'ease' },
        ],
        [
          this.contentElement,
          { opacity: [0, 1], transform: ['translateY(10px)', 'translateY(0)'] },
          { duration: 0.15, at: '<' },
        ],
      ]).finished;
    } else {
      await FoxTheme.Motion.timeline([
        [this.contentElement, { opacity: 0 }, { duration: 0.15 }],
        [
          this,
          { height: [`${this.clientHeight + 1}px`, `${this.summaryElement.clientHeight + 1}px`] },
          { duration: 0.25, at: '<', easing: 'ease' },
        ],
      ]).finished;

      this.removeAttribute('open');
      this.parentElement.classList.remove('active');
    }

    this.style.height = 'auto';
    this.style.overflow = 'visible';
  }

  designModeEventSetup() {
    this.addEventListener('shopify:block:select', () => {
      this.open = true;
    });

    this.addEventListener('shopify:block:deselect', () => {
      this.open = false;
    });
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'open') {
      this.setAttribute('aria-controls', this.contentElement.id);
    }
  }
}
customElements.define('accordion-details', AccordionDetails, { extends: 'details' });

class AccordionGroup extends AccordionDetails {
  constructor() {
    super();
  }

  handleAfterToggle() {
    if (this.isOpen) {
      const parent = this.closest('.accordion-parent') || document;
      const siblingsAccordions = parent.querySelectorAll('details[is="accordion-group"]');

      siblingsAccordions.forEach((details) => {
        if (details !== this) {
          details.open = false;
        }
      });
    }
  }
}
customElements.define('accordion-group', AccordionGroup, { extends: 'details' });

class ProgressBar extends HTMLElement {
  constructor() {
    super();

    if (this.hasAttribute('style')) return;

    if (this.dataset.from) {
      this.initProgress();
    }

    FoxTheme.Motion.inView(this, this.init.bind(this));
  }

  init() {
    this.setPercentage(this.dataset.value, this.dataset.max);
  }

  initProgress() {
    this.setPercentage(this.dataset.from, this.dataset.max);
  }

  setPercentage(val1, val2) {
    this.style.setProperty('--percent', `${(parseInt(val1) / parseInt(val2)) * 100}%`);
  }
}
customElements.define('progress-bar', ProgressBar);

class CartCount extends HTMLElement {
  constructor() {
    super();
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = FoxTheme.pubsub.subscribe(
      FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate,
      this.onCartUpdate.bind(this)
    );
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  get itemCount() {
    return parseInt(this.innerText);
  }

  get type() {
    return this.dataset.type;
  }

  onCartUpdate(event) {
    if (event.cart.errors) return;

    let count = event.cart.item_count > 99 ? '99+' : event.cart.item_count;

    if (this.type === 'blank') {
      count = `(${count})`;
    }

    if (this.classList.contains('cart-count--absolute')) {
      if (event.cart.item_count > 99) {
        this.innerHTML = `<span class="text-sm-extra">${count}</span>`;
        this.classList.add('cart-count--small-medium');
      } else {
        this.innerText = count;
        this.classList.remove('cart-count--small-medium');
      }
    } else {
      this.innerText = count;
    }

    this.hidden = this.itemCount === 0 || event.cart.item_count === 0;

    const method = this.itemCount === 0 ? 'remove' : 'add';
    document.documentElement.classList[method]('cart-has-items');
  }
}
customElements.define('cart-count', CartCount);

class QuantityInput extends HTMLElement {
  quantityUpdateUnsubscriber = undefined;
  quantityBoundriesUnsubscriber = undefined;
  quantityRulesUnsubscriber = undefined;

  constructor() {
    super();
  }

  get sectionId() {
    return this.getAttribute('data-section-id');
  }

  get productId() {
    return this.getAttribute('data-product-id');
  }

  get input() {
    return this.querySelector('input');
  }

  get value() {
    return this.input.value;
  }

  connectedCallback() {
    this.abortController = new AbortController();

    this.buttons = Array.from(this.querySelectorAll('button'));
    this.changeEvent = new Event('change', { bubbles: true });

    // The signal belongs to addEventListener, not to forEach's thisArg where it used to
    // sit: abort() detached nothing, so each reconnection doubled the click handlers.
    const { signal } = this.abortController;

    this.input.addEventListener('change', this.onInputChange.bind(this), { signal });
    this.input.addEventListener('focus', () => setTimeout(() => this.input.select()), { signal });

    this.buttons.forEach((button) => button.addEventListener('click', this.onButtonClick.bind(this), { signal }));

    this.validateQtyRules();

    this.quantityUpdateUnsubscriber = FoxTheme.pubsub.subscribe(
      FoxTheme.pubsub.PUB_SUB_EVENTS.quantityUpdate,
      this.validateQtyRules.bind(this)
    );
    this.quantityBoundriesUnsubscriber = FoxTheme.pubsub.subscribe(
      FoxTheme.pubsub.PUB_SUB_EVENTS.quantityBoundries,
      this.setQuantityBoundries.bind(this)
    );
    this.quantityRulesUnsubscriber = FoxTheme.pubsub.subscribe(
      FoxTheme.pubsub.PUB_SUB_EVENTS.quantityRules,
      this.updateQuantityRules.bind(this)
    );
  }

  disconnectedCallback() {
    this.abortController.abort();

    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
    if (this.quantityBoundriesUnsubscriber) {
      this.quantityBoundriesUnsubscriber();
    }
    if (this.quantityRulesUnsubscriber) {
      this.quantityRulesUnsubscriber();
    }
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    if (event.currentTarget.name === 'plus') {
      if (parseInt(this.input.getAttribute('data-min')) > parseInt(this.input.step) && this.input.value == 0) {
        this.input.value = this.input.getAttribute('data-min');
      } else {
        this.input.stepUp();
      }
    } else {
      this.input.stepDown();
    }

    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);

    if (this.input.getAttribute('data-min') === previousValue && event.currentTarget.name === 'minus') {
      this.input.value = parseInt(this.input.min);
    }
  }

  onInputChange() {
    if (this.input.value === '') {
      this.input.value = parseInt(this.input.min);
    }
    this.validateQtyRules();
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const buttonMinus = this.querySelector('button[name="minus"]');
      if (buttonMinus) buttonMinus.toggleAttribute('disabled', parseInt(value) <= parseInt(this.input.min));
    }
    if (this.input.max) {
      const buttonPlus = this.querySelector('button[name="plus"]');
      if (buttonPlus) buttonPlus.toggleAttribute('disabled', parseInt(value) >= parseInt(this.input.max));
    }
  }

  updateQuantityRules({ data: { sectionId, productId, parsedHTML } }) {
    if (sectionId !== this.sectionId || productId !== this.productId) return;
    const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
    const quantityFormUpdated = parsedHTML.getElementById(`QuantityForm-${sectionId}`);
    const quantityForm = this.closest(`#QuantityForm-${sectionId}`);
    for (let selector of selectors) {
      const current = quantityForm.querySelector(selector);
      const updated = quantityFormUpdated?.querySelector(selector);
      if (!current || !updated) continue;

      if (selector === '.quantity__input') {
        const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
        for (let attribute of attributes) {
          const valueUpdated = updated.getAttribute(attribute);
          if (valueUpdated !== null) {
            current.setAttribute(attribute, valueUpdated);
          } else {
            current.removeAttribute(attribute);
          }
        }
      } else {
        current.innerHTML = updated.innerHTML;
      }
    }
  }

  setQuantityBoundries({ data: { sectionId, productId } }) {
    if (sectionId !== this.sectionId || productId !== this.productId) return;
    const data = {
      cartQuantity: this.input.hasAttribute('data-cart-quantity')
        ? parseInt(this.input.getAttribute('data-cart-quantity'))
        : 0,
      min: this.input.hasAttribute('data-min') ? parseInt(this.input.getAttribute('data-min')) : 1,
      max: this.input.hasAttribute('data-max') ? parseInt(this.input.getAttribute('data-max')) : null,
      step: this.input.hasAttribute('step') ? parseInt(this.input.getAttribute('step')) : 1,
    };

    let min = data.min;
    const max = data.max === null ? data.max : data.max - data.cartQuantity;
    if (max !== null) min = Math.min(min, max);
    if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

    this.input.min = min;

    if (max) {
      this.input.max = max;
    } else {
      this.input.removeAttribute('max');
    }
    this.input.value = min;

    FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.quantityUpdate, undefined);
  }
}
customElements.define('quantity-input', QuantityInput);

class QuantitySelector extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.abortController = new AbortController();

    this.input = this.querySelector('input');
    this.buttons = Array.from(this.querySelectorAll('button'));
    this.changeEvent = new Event('change', { bubbles: true });

    this.buttons.forEach((button) => button.addEventListener('click', this.onButtonClick.bind(this)), {
      signal: this.abortController.signal,
    });
  }

  disconnectedCallback() {
    this.abortController.abort();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    if (event.currentTarget.name === 'plus') {
      this.input.quantity = this.input.quantity + 1;
    } else {
      this.input.quantity = this.input.quantity - 1;
    }

    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}
customElements.define('quantity-selector', QuantitySelector);

const onYouTubeApiLoaded = new Promise((resolve) => {
  window.onYouTubeIframeAPIReady = () => resolve();
});
class VideoElement extends HTMLElement {
  constructor() {
    super();

    if (this.posterElement) {
      this.posterElement.addEventListener('click', this.handlePosterClick.bind(this));
    }

    if (this.autoplay) {
      FoxTheme.Motion.inView(this, () => {
        if (!this.paused) {
          this.play();
        }

        return () => {
          this.pause();
        };
      });
    }
  }

  get posterElement() {
    return this.querySelector('[id^="DeferredPoster-"]');
  }

  get controlledElement() {
    return this.hasAttribute('aria-controls') ? document.getElementById(this.getAttribute('aria-controls')) : null;
  }

  get autoplay() {
    return this.hasAttribute('autoplay');
  }

  get playing() {
    return this.hasAttribute('playing');
  }

  get player() {
    if (this.playerProxy) {
      return this.playerProxy;
    }

    // Wrap initializePlayer to ensure it always returns a Promise or object (never null directly)
    const playerInit = this.initializePlayer();
    const playerPromise = playerInit instanceof Promise ? playerInit : Promise.resolve(playerInit);

    // Create a proxy with a placeholder object to avoid "Cannot create proxy with null" error
    const placeholder = {};
    this.playerProxy = new Proxy(placeholder, {
      get: (target, prop) => {
        return async () => {
          const resolvedPlayer = await playerPromise;
          if (!resolvedPlayer) {
            console.warn('VideoElement: player is null, cannot perform action:', prop);
            return;
          }
          this.handlePlayerAction(resolvedPlayer, prop);
        };
      },
    });

    return this.playerProxy;
  }

  static get observedAttributes() {
    return ['playing'];
  }

  handlePosterClick(event) {
    event.preventDefault();
    event.stopPropagation();

    if (this.playing) {
      this.paused = true;
      this.pause();
    } else {
      this.paused = false;
      this.play();
    }
  }

  play() {
    if (!this.playing) {
      const playerResult = this.player;
      if (playerResult) {
        playerResult.play();
      }
    }
  }

  pause() {
    if (this.playing) {
      const playerResult = this.player;
      if (playerResult) {
        playerResult.pause();
      }
    }
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'playing') {
      if (oldValue === null && newValue === '') {
        return this.dispatchEvent(new CustomEvent('video:play', { bubbles: true }));
      }

      if (newValue === null) {
        return this.dispatchEvent(new CustomEvent('video:pause', { bubbles: true }));
      }
    }
  }

  initializePlayer() {
    if (this.hasAttribute('source')) {
      this.setAttribute('loaded', '');
      this.closest('.media')?.classList.remove('loading');

      return new Promise(async (resolve) => {
        const templateElement = this.querySelector('template');
        if (templateElement) {
          templateElement.replaceWith(templateElement.content.firstElementChild.cloneNode(true));
        }
        const muteVideo = this.hasAttribute('autoplay') || window.matchMedia('screen and (max-width: 1023px)').matches;
        const script = document.createElement('script');
        script.type = 'text/javascript';
        if (this.getAttribute('source') === 'youtube') {
          if (!window.YT || !window.YT.Player) {
            script.src = 'https://www.youtube.com/iframe_api';
            document.head.appendChild(script);
            await new Promise((resolve2) => {
              script.onload = resolve2;
            });
          }
          await onYouTubeApiLoaded;
          const iframe = this.querySelector('iframe');
          if (!iframe) {
            console.warn('VideoElement: iframe not found for YouTube player');
            resolve(null);
            return;
          }
          const player = new YT.Player(iframe, {
            events: {
              onReady: () => {
                if (muteVideo) {
                  player.mute();
                }
                resolve(player);
              },
              onStateChange: (event) => {
                if (event.data === YT.PlayerState.PLAYING) {
                  this.setAttribute('playing', '');
                } else if (event.data === YT.PlayerState.ENDED || event.data === YT.PlayerState.PAUSED) {
                  this.removeAttribute('playing');
                }
              },
            },
          });
        }
        if (this.getAttribute('source') === 'vimeo') {
          if (!window.Vimeo || !window.Vimeo.Player) {
            script.src = 'https://player.vimeo.com/api/player.js';
            document.head.appendChild(script);
            await new Promise((resolve2) => {
              script.onload = resolve2;
            });
          }
          const iframe = this.querySelector('iframe');
          if (!iframe) {
            console.warn('VideoElement: iframe not found for Vimeo player');
            resolve(null);
            return;
          }
          const player = new Vimeo.Player(iframe);
          if (muteVideo) {
            player.setMuted(true);
          }
          player.on('play', () => {
            this.setAttribute('playing', '');
          });
          player.on('pause', () => this.removeAttribute('playing'));
          player.on('ended', () => this.removeAttribute('playing'));
          resolve(player);
        }
      });
    } else {
      const templateElement = this.querySelector('template');
      if (!templateElement) {
        console.warn('VideoElement: template not found');
        return null;
      }

      const templateContent = templateElement.content.firstElementChild;
      this.appendChild(templateContent.cloneNode(true));
      this.setAttribute('loaded', '');
      this.closest('.media')?.classList.remove('loading');

      // Check if template contains iframe instead of video (edge case: iframe without source attribute)
      const iframe = this.querySelector('iframe');
      if (iframe) {
        console.warn('VideoElement: iframe found but no source attribute set. Cannot initialize player.');
        return null;
      }

      const player = this.querySelector('video');
      if (!player) {
        console.warn('VideoElement: video element not found after cloning template');
        return null;
      }

      // Double check: ensure player is a valid video element
      if (!(player instanceof HTMLVideoElement) || typeof player.addEventListener !== 'function') {
        console.warn('VideoElement: player is not a valid HTMLVideoElement');
        return null;
      }

      player.addEventListener('play', () => {
        this.setAttribute('playing', '');
        this.removeAttribute('suspended');
      });
      player.addEventListener('pause', () => {
        if (!player.seeking && player.paused) {
          this.removeAttribute('playing');
        }
      });
      return player;
    }
  }

  handlePlayerAction(target, prop) {
    if (!target) {
      console.warn('VideoElement: player target is null, cannot perform action:', prop);
      return;
    }

    if (this.getAttribute('source') === 'youtube') {
      prop === 'play' ? target.playVideo() : target.pauseVideo();
    } else {
      if (prop === 'play' && !this.hasAttribute('source')) {
        target.play().catch((error) => {
          if (error.name === 'NotAllowedError') {
            this.setAttribute('suspended', '');
            target.controls = true;
            const replacementImageSrc = target.previousElementSibling?.currentSrc;
            if (replacementImageSrc) {
              target.poster = replacementImageSrc;
            }
          }
        });
      } else {
        target[prop]();
      }
    }
  }
}
customElements.define('video-element', VideoElement);

class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
      button: this.querySelector('button'),
      panel: this.querySelector('.disclosure-list'),
    };

    this.elements.panel.removeAttribute('hidden');
    this.elements.button.addEventListener('click', this.openSelector.bind(this));
    this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
    this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

    this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));

    this.handleDropdownPos();
  }

  handleDropdownPos() {
    const offsetButton = this.elements.button.getBoundingClientRect().right;
    if (window.innerWidth - offsetButton < 220) {
      this.elements.button.nextElementSibling &&
        this.elements.button.nextElementSibling.classList.add('disclosure-list__right');
    }
  }

  hidePanel() {
    this.elements.button.setAttribute('aria-expanded', 'false');
    this.removeAttribute('open');
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    this.hidePanel();
    this.elements.button.focus();
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }

  openSelector() {
    this.elements.button.focus();
    this.toggleAttribute('open');
    this.elements.button.setAttribute(
      'aria-expanded',
      (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
    );
  }

  closeSelector(event) {
    const shouldClose =
      (event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON') ||
      (event.relatedTarget && !event.relatedTarget.classList.contains('disclosure-list__option'));
    if (event.relatedTarget === null || shouldClose) {
      this.hidePanel(shouldClose);
    }
  }
}
customElements.define('localization-form', LocalizationForm);

class GridList extends HTMLElement {
  constructor() {
    super();

    if (FoxTheme.config.motionReduced || this.hasAttribute('motion-reduced')) return;

    this.hideGridItems();
    FoxTheme.Motion.inView(this, this.showGridItems.bind(this), { margin: '0px 0px -50px 0px' });
  }

  get gridItems() {
    return this.querySelectorAll('.f-column');
  }

  get visibleGridItems() {
    return this.querySelectorAll('.f-column:not([style])');
  }

  hideGridItems() {
    FoxTheme.Motion.animate(
      this.gridItems,
      { transform: 'translateY(3.5rem)', opacity: 0.01, visibility: 'hidden' },
      { duration: 0 }
    );
  }

  showGridItems() {
    FoxTheme.Motion.animate(
      this.gridItems,
      { transform: ['translateY(3.5rem)', 'translateY(0)'], opacity: [0.01, 1], visibility: ['hidden', 'visible'] },
      {
        duration: 0.5,
        delay: FoxTheme.config.motionReduced ? 0 : FoxTheme.Motion.stagger(0.1),
        easing: [0, 0, 0.3, 1],
      }
    );
  }

  reShowVisibleGridItems() {
    FoxTheme.Motion.animate(
      this.visibleGridItems,
      { transform: ['translateY(3.5rem)', 'translateY(0)'], opacity: [0.01, 1], visibility: ['hidden', 'visible'] },
      { duration: 0.5, delay: FoxTheme.config.motionReduced ? 0 : FoxTheme.Motion.stagger(0.1), easing: [0, 0, 0.3, 1] }
    );
  }
}
customElements.define('grid-list', GridList);

class AnnouncementBar extends HTMLElement {
  constructor() {
    super();
    this.announcementItemsWrapper = this.querySelector('.swiper-wrapper');

    FoxTheme.Motion.inView(this, this.initializeCarousel.bind(this), { margin: '200px 0px 200px 0px' });
  }

  getNextSlideButton() {
    return this.querySelector('.swiper-button-next');
  }

  getPrevSlideButton() {
    return this.querySelector('.swiper-button-prev');
  }

  get getSlideItems() {
    return (this._cachedSlideItems = this._cachedSlideItems || Array.from(this.announcementItemsWrapper.children));
  }

  isAutoplayEnabled() {
    return this.hasAttribute('autoplay');
  }

  getAutoplaySpeed() {
    return this.hasAttribute('autoplay') ? parseInt(this.getAttribute('autoplay-speed')) * 1000 : 5000;
  }

  initializeCarousel() {
    if (this.getSlideItems.length > 1) {
      this.carousel = new FoxTheme.Carousel(
        this,
        {
          navigation: {
            nextEl: this.getNextSlideButton(),
            prevEl: this.getPrevSlideButton(),
          },
          loop: true,
          autoplay: this.isAutoplayEnabled() ? { delay: this.getAutoplaySpeed(), pauseOnMouseEnter: true } : false,
        },
        [FoxTheme.Swiper.Autoplay]
      );
      this.carousel && this.carousel.init();

      if (Shopify.designMode) {
        this.addEventListener('shopify:block:select', (event) => {
          this.carousel.slider.slideToLoop(this.getSlideItems.indexOf(event.target));
        });
      }
    }
  }
}
customElements.define('announcement-bar', AnnouncementBar);

class SelectElement extends HTMLElement {
  constructor() {
    super();

    FoxTheme.Motion.inView(this, this.init.bind(this), { margin: '200px 0px 200px 0px' });

    this.select = this.querySelector('select');

    this.select && this.select.addEventListener('change', this.handleSelectChange.bind(this));
  }

  init() {
    const style = window.getComputedStyle(this);
    const value = this.select.options[this.select.selectedIndex].text;

    const text = document.createElement('span');
    text.style.fontFamily = style.fontFamily;
    text.style.fontSize = style.fontSize;
    text.style.fontWeight = style.fontWeight;
    text.style.visibility = 'hidden';
    text.style.position = 'absolute';
    text.innerHTML = value;

    document.body.appendChild(text);
    const width = text.clientWidth;

    this.style.setProperty('--width', `${width}px`);
    text.remove();
  }

  handleSelectChange() {
    this.init();
  }
}
customElements.define('select-element', SelectElement);

class ProductRecentlyViewed extends HTMLElement {
  constructor() {
    super();

    if (FoxTheme.config.hasLocalStorage) {
      const productId = parseInt(this.dataset.productId);
      const cookieName = 'hypertheme:recently-viewed';
      const items = JSON.parse(window.localStorage.getItem(cookieName) || '[]');

      if (items.includes(productId)) {
        items.splice(items.indexOf(productId), 1);
      }

      items.unshift(productId);

      window.localStorage.setItem(cookieName, JSON.stringify(items.slice(0, 20)));
    }
  }
}
customElements.define('product-recently-viewed', ProductRecentlyViewed);

/**
 * MotionObserverManager - Shared IntersectionObserver for all motion-elements
 *
 * Benefits:
 * - Reduces memory usage: 1 observer instead of N observers (N = number of motion-elements)
 * - Better performance on Safari with many elements (60+ images)
 * - Prevents memory leaks from multiple observer instances
 *
 * Memory impact: ~98% reduction in observer overhead
 * Example: 60 elements × 50KB = 3MB → 1 observer = 50KB
 */
class MotionObserverManager {
  constructor() {
    this.observer = null;
    this.elements = new WeakMap(); // WeakMap ensures proper garbage collection
    this.initialize();
  }

  initialize() {
    if (FoxTheme.config.motionReduced) return;

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const callback = this.elements.get(entry.target);
            if (callback) {
              callback();
              this.unobserve(entry.target);
            }
          }
        });
      },
      { rootMargin: '0px 0px -80px 0px' }
    );
  }

  observe(element, callback) {
    if (!this.observer) return;
    this.elements.set(element, callback);
    this.observer.observe(element);
  }

  unobserve(element) {
    if (!this.observer) return;
    this.observer.unobserve(element);
    this.elements.delete(element);
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect();
      this.elements = new WeakMap();
    }
  }
}

// Create singleton instance
FoxTheme.MotionObserver = new MotionObserverManager();

/**
 * MotionElement - Optimized custom element for animations
 *
 * Key optimizations:
 * - Shared IntersectionObserver via MotionObserverManager
 * - Event-based parent waiting (no setTimeout polling)
 * - Proper cleanup in disconnectedCallback
 * - Cached media elements (no repeated DOM queries)
 * - AbortController pattern for cancellable animations
 *
 * Fixes Safari crash issues with 60+ product images
 */
class MotionElement extends HTMLElement {
  constructor() {
    super();

    // Instance properties for cleanup tracking
    this._parentCheckTimer = null;
    this._abortController = null;
    this._cachedMediaElements = null;
    this._isObserving = false;
    this._parentEventHandler = null;
  }

  connectedCallback() {
    if (FoxTheme.config.motionReduced) return;

    const parentMotionElement = this.closest('motion-element:not(:scope)');

    if (parentMotionElement) {
      this.waitForParent(parentMotionElement);
    } else {
      this.preInitialize();
      this.setupObserver();
    }
  }

  disconnectedCallback() {
    this.cleanup();
  }

  cleanup() {
    // Clear parent check timer
    if (this._parentCheckTimer) {
      clearTimeout(this._parentCheckTimer);
      this._parentCheckTimer = null;
    }

    // Remove parent event listener
    if (this._parentEventHandler) {
      const parent = this.closest('motion-element:not(:scope)');
      if (parent) {
        parent.removeEventListener('motion-initialized', this._parentEventHandler);
      }
      this._parentEventHandler = null;
    }

    // Unobserve from IntersectionObserver
    if (this._isObserving) {
      FoxTheme.MotionObserver.unobserve(this);
      this._isObserving = false;
    }

    // Abort any pending animations
    if (this._abortController) {
      this._abortController.abort();
      this._abortController = null;
    }

    // Clear cached elements
    this._cachedMediaElements = null;

    // Remove initialized attribute
    this.removeAttribute('data-initialized');
  }

  waitForParent(parentMotionElement) {
    // Use event-based approach instead of polling for better performance
    if (parentMotionElement.hasAttribute('data-initialized')) {
      this.preInitialize();
      this.setupObserver();
    } else {
      // Listen for parent initialization event
      this._parentEventHandler = () => {
        this.preInitialize();
        this.setupObserver();
      };
      parentMotionElement.addEventListener('motion-initialized', this._parentEventHandler, { once: true });

      // Fallback timeout in case event doesn't fire (max 5 seconds to prevent infinite waiting)
      this._parentCheckTimer = setTimeout(() => {
        if (!this.hasAttribute('data-initialized')) {
          this.preInitialize();
          this.setupObserver();
        }
      }, 5000);
    }
  }

  setupObserver() {
    this._isObserving = true;
    FoxTheme.MotionObserver.observe(this, async () => {
      try {
        if (!this.isInstant && this.mediaElements.length > 0) {
          await FoxTheme.utils.imageReady(this.mediaElements);
        }
        await this.initialize();
      } catch (error) {
        // Silently handle errors from disconnected elements
        if (this.isConnected) {
          console.warn('Motion animation error:', error);
        }
      }
    });
  }

  get isHold() {
    return this.hasAttribute('hold');
  }

  get isInstant() {
    return this.hasAttribute('data-instantly');
  }

  get mediaElements() {
    // Cache media elements to avoid repeated DOM queries (performance optimization)
    if (!this._cachedMediaElements) {
      this._cachedMediaElements = Array.from(this.querySelectorAll('img, iframe, svg'));
    }
    return this._cachedMediaElements;
  }

  get animationType() {
    return this.dataset.motion || 'fade-up';
  }

  get animationDelay() {
    return parseInt(this.dataset.motionDelay || 0) / 1000;
  }

  preInitialize() {
    if (this.isHold) return;

    // Create abort controller for animations
    this._abortController = new AbortController();

    switch (this.animationType) {
      case 'fade-in':
        this.style.visibility = 'hidden';
        FoxTheme.Motion.animate(this, { opacity: 0.01 }, { duration: 0 });
        break;

      case 'fade-up':
        this.style.visibility = 'hidden';
        FoxTheme.Motion.animate(this, { transform: 'translateY(2.5rem)', opacity: 0.01 }, { duration: 0 });
        break;

      case 'zoom-in':
        FoxTheme.Motion.animate(this, { transform: 'scale(0.8)' }, { duration: 0 });
        break;

      case 'zoom-in-lg':
        FoxTheme.Motion.animate(this, { transform: 'scale(0)' }, { duration: 0 });
        break;

      case 'zoom-out':
        FoxTheme.Motion.animate(this, { transform: 'scale(1.08)' }, { duration: 0 });
        break;

      case 'zoom-out-sm':
        FoxTheme.Motion.animate(this, { transform: 'scale(1.03)' }, { duration: 0 });
        break;
    }
  }

  async initialize() {
    if (this.isHold) return;

    // Check if element is still connected before animating
    if (!this.isConnected) return;

    this.setAttribute('data-initialized', 'true');

    // Dispatch custom event for child elements to listen
    this.dispatchEvent(new CustomEvent('motion-initialized', { bubbles: false }));

    try {
      switch (this.animationType) {
        case 'fade-in':
          this.style.visibility = 'visible';
          await FoxTheme.Motion.animate(
            this,
            { opacity: 1 },
            { duration: 1.5, delay: this.animationDelay, easing: [0, 0, 0.3, 1] }
          ).finished;
          break;

        case 'fade-up':
          this.style.visibility = 'visible';
          await FoxTheme.Motion.animate(
            this,
            { transform: 'translateY(0)', opacity: 1 },
            { duration: 0.5, delay: this.animationDelay, easing: [0, 0, 0.3, 1] }
          ).finished;
          break;

        case 'zoom-in':
          await FoxTheme.Motion.animate(
            this,
            { transform: 'scale(1)' },
            { duration: 1.3, delay: this.animationDelay, easing: [0, 0, 0.3, 1] }
          ).finished;
          break;

        case 'zoom-in-lg':
          await FoxTheme.Motion.animate(
            this,
            { transform: 'scale(1)' },
            { duration: 0.5, delay: this.animationDelay, easing: [0, 0, 0.3, 1] }
          ).finished;
          break;

        case 'zoom-out':
          await FoxTheme.Motion.animate(
            this,
            { transform: 'scale(1)' },
            { duration: 1.5, delay: this.animationDelay, easing: [0, 0, 0.3, 1] }
          ).finished;
          break;

        case 'zoom-out-sm':
          await FoxTheme.Motion.animate(
            this,
            { transform: 'scale(1)' },
            { duration: 1, delay: this.animationDelay, easing: [0, 0, 0.3, 1] }
          ).finished;
          break;
      }
    } catch (error) {
      // Animation was cancelled or element was removed
      if (error.name !== 'AbortError' && this.isConnected) {
        console.warn('Motion animation error:', error);
      }
    }
  }

  async resetAnimation(duration) {
    if (!this.isConnected) return;

    try {
      switch (this.animationType) {
        case 'fade-in':
          await FoxTheme.Motion.animate(
            this,
            { opacity: 0 },
            {
              duration: duration ? duration : 1.5,
              delay: this.animationDelay,
              easing: duration ? 'none' : [0, 0, 0.3, 1],
            }
          ).finished;
          break;

        case 'fade-up':
          await FoxTheme.Motion.animate(
            this,
            { transform: 'translateY(2.5rem)', opacity: 0 },
            {
              duration: duration ? duration : 0.5,
              delay: this.animationDelay,
              easing: duration ? 'none' : [0, 0, 0.3, 1],
            }
          ).finished;
          break;

        case 'zoom-in':
        case 'zoom-in-lg':
        case 'zoom-out':
        case 'zoom-out-sm':
          await FoxTheme.Motion.animate(
            this,
            { transform: 'scale(0)' },
            {
              duration: duration ? duration : 1.3,
              delay: this.animationDelay,
              easing: duration ? 'none' : [0, 0, 0.3, 1],
            }
          ).finished;
          break;
      }
    } catch (error) {
      if (error.name !== 'AbortError' && this.isConnected) {
        console.warn('Motion reset error:', error);
      }
    }
  }

  refreshAnimation() {
    this.removeAttribute('hold');
    this.preInitialize();
    setTimeout(() => {
      if (this.isConnected) {
        this.initialize();
      }
    }, 50); // Delay a bit to make animation re init properly.
  }
}
customElements.define('motion-element', MotionElement);

class TabsComponent extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      tabHeader: '[role="tablist"]',
      tabPanels: ['[role="tabpanel"]'],
      tabNavs: ['[role="tab"]'],
      tabNav: '.tabs__nav-js',
    };
    this.domNodes = FoxTheme.utils.queryDomNodes(this.selectors, this);

    this.selectedIndex = 0;
    this.selectedTab = this.domNodes.tabPanels[this.selectedIndex];
    this.scrollToActiveTab = this.dataset.scrollToActiveTab === 'true';
    this.scrollOffset = 20;
    this.headerEl = document.querySelector('.header-section header[is="sticky-header"]');

    this.init();
    this.setActiveTab(0);

    this.tabChange = new CustomEvent('tabChange', {
      bubbles: true,
      detail: { selectedTab: this.selectedTab },
    });
  }

  connectedCallback() {
    this.setActiveTab(0);
  }

  init = () => {
    this.buttons.forEach((tab) => {
      tab.addEventListener('click', this.onTabClick.bind(this));
    });
    this.domNodes.tabHeader && this.domNodes.tabHeader.addEventListener('keydown', this.handleKeyDown.bind(this));
    this.setAccessible();
  };

  static get observedAttributes() {
    return ['data-selected'];
  }

  get buttons() {
    return (this._buttons = this._buttons || Array.from(this.domNodes.tabNavs));
  }

  getHeaderHeight() {
    let headerHeight = 0;

    if (this.headerEl) {
      const height = Math.round(this.headerEl.offsetHeight);
      if (this.headerEl.isAlwaysSticky) {
        headerHeight = height;
      } else {
        const isSticky = document.body.classList.contains(this.headerEl.classes.pinned);

        if (window.scrollY > this.offsetTop - this.scrollOffset) {
          headerHeight = height;
        }

        if (isSticky && window.scrollY >= this.offsetTop - this.scrollOffset - height) {
          headerHeight = height;
        }
      }
    }

    return headerHeight;
  }

  scrollToTop() {
    let offsetTop = this.offsetTop - this.scrollOffset - this.getHeaderHeight();
    window.scrollTo({ top: offsetTop, behavior: 'smooth' });
  }

  onTabClick(evt) {
    evt.preventDefault();
    const currentTab = evt.currentTarget;
    const index = currentTab ? Number(currentTab.dataset.index) : 0;
    this.setActiveTab(index);

    if (this.scrollToActiveTab) {
      this.scrollToTop();
    }
  }

  setActiveTab = (tabIndex) => {
    const { tabNavs, tabPanels } = this.domNodes;
    if (tabIndex !== -1) {
      const newHeader = tabNavs && tabNavs[tabIndex];
      const newTab = tabPanels && tabPanels[tabIndex];
      this.setAttribute('data-selected', tabIndex);

      tabNavs.forEach((nav) => nav.setAttribute('aria-selected', false));

      newHeader && newHeader.setAttribute('aria-selected', true);

      this.selectedIndex = tabIndex;
      this.selectedTab = newTab;

      this.dispatchEvent(
        new CustomEvent('tabChange', {
          bubbles: true,
          detail: { selectedIndex: tabIndex, selectedTab: newTab },
        })
      );
    }
  };

  setAccessible() {
    const { tabNavs, tabPanels } = this.domNodes;
    tabNavs.forEach((tab, index) => {
      if (tab.id) tabPanels[index].setAttribute('aria-labelledby', tab.id);
      tab.setAttribute('aria-selected', index === 0);
      tab.setAttribute('data-index', index);
      if (index !== 0) {
        // tab.setAttribute('tabindex', -1);
      }
    });
    tabPanels.forEach((panel, index) => {
      if (panel.id) tabNavs[index].setAttribute('aria-controls', panel.id);
      panel.setAttribute('tabindex', 0);
    });
  }

  handleKeyDown(e) {
    const { tabNavs } = this.domNodes;
    if (e.keyCode === 39 || e.keyCode === 37) {
      tabNavs[this.selectedIndex].setAttribute('tabindex', -1);
      if (e.keyCode === 39) {
        this.selectedIndex++;
        // If we're at the end, go to the start.
        if (this.selectedIndex >= tabNavs.length) {
          this.selectedIndex = 0;
        }
        // Move left.
      } else if (e.keyCode === 37) {
        this.selectedIndex--;
        // If we're at the start, move to the end.
        if (this.selectedIndex < 0) {
          this.selectedIndex = tabNavs.length - 1;
        }
      }

      tabNavs[this.selectedIndex].setAttribute('tabindex', 0);
      tabNavs[this.selectedIndex].focus();
    }
  }

  getSelected() {
    return {
      index: this.selectedIndex,
      element: this.selectedTab,
    };
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'data-selected' && oldValue !== null && oldValue !== newValue) {
      const fromButton = this.buttons[parseInt(oldValue)];
      const toButton = this.buttons[parseInt(newValue)];
      this.transition(
        document.getElementById(fromButton.getAttribute('aria-controls')),
        document.getElementById(toButton.getAttribute('aria-controls'))
      );

      this.scrollToActiveButton(toButton);
    }
  }

  scrollToActiveButton(toButton) {
    if (!this.domNodes.tabNav) return;
    const containerGap = 15;
    const scrollRect = toButton.getBoundingClientRect();
    const boxRect = this.domNodes.tabNav.getBoundingClientRect();
    const scrollLeft = this.domNodes.tabNav.scrollLeft;
    const scrollOffset = scrollRect.x + scrollLeft - boxRect.x - containerGap;

    this.domNodes.tabNav.scrollTo({
      left: scrollOffset,
      behavior: 'smooth',
    });
  }

  async transition(fromPanel, toPanel) {
    await FoxTheme.Motion.animate(
      fromPanel,
      { transform: ['translateY(0)', 'translateY(2rem)'], opacity: [1, 0] },
      { duration: 0.3 }
    ).finished;

    fromPanel.hidden = true;
    toPanel.hidden = false;

    FoxTheme.Motion.animate(
      toPanel,
      { transform: ['translateY(2rem)', 'translateY(0)'], opacity: [0, 1] },
      { duration: 0.3 }
    ).finished;

    toPanel.querySelector('grid-list') && toPanel.querySelector('grid-list').showGridItems();
  }
}
customElements.define('tabs-component', TabsComponent);
/*
Uncomment when use
class TabSelector extends HTMLElement {
  constructor() {
    super();

    this.tabs = this.closest('tabs-component');

    this.querySelector('select').addEventListener('change', (e) => {
      this.tabs.setActiveTab(e.target.value);
    });

    this.tabs.addEventListener('tabChange', this.onTabChange.bind(this));
  }

  onTabChange(event) {
    this.querySelector('select').value = event.detail.selectedIndex;
  }
}
customElements.define('tab-selector', TabSelector);
*/
class Parallax extends HTMLElement {
  get parallax() {
    return this.dataset.parallax ? parseFloat(this.dataset.parallax) : false;
  }

  get parallaxDirection() {
    return this.dataset.parallaxDirection || 'vertical';
  }

  get parallaxMediaElements() {
    return Array.from(this.querySelectorAll('img, video, iframe, svg, video-element'));
  }

  connectedCallback() {
    if (this.shouldInitializeParallax()) {
      this.setupParallax();
    }
  }

  shouldInitializeParallax() {
    return !FoxTheme.config.motionReduced && this.parallax;
  }

  setupParallax() {
    const parallaxScale = 1 + this.parallax;
    const parallaxTranslate = (this.parallax * 100) / (1 + this.parallax);

    let parallaxTransformProperties = {};

    if (this.parallaxDirection === 'vertical') {
      parallaxTransformProperties = {
        transform: [
          `scale(${parallaxScale}) translateY(0)`,
          `scale(${parallaxScale}) translateY(${parallaxTranslate}%)`,
        ],
        transformOrigin: ['bottom', 'bottom'],
      };
    } else if (this.parallaxDirection === 'horizontal') {
      parallaxTransformProperties = {
        transform: [
          `scale(${parallaxScale}) translateX(0)`,
          `scale(${parallaxScale}) translateX(${parallaxTranslate}%)`,
        ],
        transformOrigin: ['right', 'right'],
      };
    } else {
      parallaxTransformProperties = {
        transform: [`scale(1)`, `scale(${parallaxScale})`],
        transformOrigin: ['center', 'center'],
      };
    }

    FoxTheme.Motion.scroll(
      FoxTheme.Motion.animate(this.parallaxMediaElements, parallaxTransformProperties, { easing: 'linear' }),
      {
        target: this,
        offset: ['start end', 'end start'],
      }
    );
  }
}
customElements.define('parallax-element', Parallax);

// Reusable toast notification.
// A single .toast-stack container is lazily created on <body>; each toast is a
// <foxtheme-toast> element that handles its own entrance, auto-dismiss and removal.
class ToastNotification extends HTMLElement {
  connectedCallback() {
    const parsedDuration = parseInt(this.getAttribute('duration'), 10);
    this.duration = Number.isNaN(parsedDuration) ? 4500 : parsedDuration;

    const closeButton = this.querySelector('[data-toast-close]');
    if (closeButton) closeButton.addEventListener('click', () => this.dismiss());

    // Defer one frame so the entrance transition runs.
    requestAnimationFrame(() => this.classList.add('toast--visible'));
    this.startTimer();

    // Pause auto-dismiss while hovered/focused so the user can read or click the link.
    this.addEventListener('mouseenter', () => this.clearTimer());
    this.addEventListener('mouseleave', () => this.startTimer());
    this.addEventListener('focusin', () => this.clearTimer());
    this.addEventListener('focusout', () => this.startTimer());
  }

  disconnectedCallback() {
    this.clearTimer();
  }

  startTimer() {
    this.clearTimer();
    if (this.duration > 0) {
      this.dismissTimer = window.setTimeout(() => this.dismiss(), this.duration);
    }
  }

  clearTimer() {
    window.clearTimeout(this.dismissTimer);
  }

  dismiss() {
    if (this.classList.contains('toast--leaving')) return;
    this.clearTimer();

    this.classList.add('toast--leaving');
    this.classList.remove('toast--visible');

    const remove = () => this.remove();
    this.addEventListener('transitionend', remove, { once: true });
    // Fallback in case transitionend never fires.
    window.setTimeout(remove, 400);
  }
}
customElements.define('foxtheme-toast', ToastNotification);

/**
 * Show a transient toast notification.
 * @param {string} message - Main text of the toast.
 * @param {object} [options]
 * @param {'default'|'positive'|'error'} [options.type='default'] - Color variant.
 * @param {number} [options.duration=4500] - Auto-dismiss delay in ms (0 to disable).
 * @param {{ label: string, href: string }} [options.link] - Optional action link.
 * @param {boolean} [options.dismissible=true] - Whether to show the close button.
 * @returns {ToastNotification|null}
 */
FoxTheme.toast = (message, { type = 'default', duration = 4500, link = null, dismissible = true } = {}) => {
  if (!message) return null;

  // The container is normally pre-rendered empty in layout/theme.liquid so the
  // live region is registered before the first toast is announced. Creating it
  // here is only a fallback in case that markup is missing.
  let stack = document.querySelector('.toast-stack');
  if (!stack) {
    stack = document.createElement('div');
    stack.className = 'toast-stack';
    stack.setAttribute('role', 'status');
    stack.setAttribute('aria-live', 'polite');
    document.body.appendChild(stack);
  }

  const toast = document.createElement('foxtheme-toast');
  toast.className = `toast toast--${type}`;
  toast.setAttribute('duration', duration);

  const row = document.createElement('div');
  row.className = 'toast__row';

  const messageEl = document.createElement('div');
  messageEl.className = 'toast__message';
  messageEl.textContent = message;
  row.appendChild(messageEl);

  if (dismissible) {
    const closeButton = document.createElement('button');
    closeButton.type = 'button';
    closeButton.className = 'toast__close';
    closeButton.setAttribute('data-toast-close', '');
    closeButton.setAttribute('aria-label', 'Fermer');
    closeButton.innerHTML =
      '<svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
      '<path d="M1 1L11 11M11 1L1 11" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';
    row.appendChild(closeButton);
  }

  toast.appendChild(row);

  if (link && link.label && link.href) {
    const linkEl = document.createElement('a');
    linkEl.className = 'toast__link';
    linkEl.href = link.href;
    linkEl.textContent = link.label;
    toast.appendChild(linkEl);
  }

  stack.appendChild(toast);

  return toast;
};

// Purchase flow drawer — dedicated multi-step drawer (contremarque → pack → add).
class PackStepController {
  constructor(drawer) {
    this.drawer = drawer;
    this._onPackOptionChange = null;
  }

  query(selector) {
    return this.drawer.querySelector(selector);
  }

  // Shopify product_type value used to identify Pack placeholder products.
  get packProductType() {
    return 'pack';
  }

  // Storefront GraphQL API version used for the pack tag lookup. Shopify retires API
  // versions roughly a year after release — bump this periodically.
  get graphqlApiVersion() {
    return '2026-07';
  }

  normalizeSku(value = '') {
    return String(value).trim().toLowerCase();
  }

  normalizeProductType(value = '') {
    return String(value).trim().toLowerCase();
  }

  // Converts a Storefront API money amount into integer cents. `price { amount }` is always
  // a decimal string in currency units ("10500.0"), never cents — so never try to guess the
  // unit from the magnitude: a 10 000+ price would be read as cents and divided by 100.
  toCents(value) {
    const n = Number(value || 0);
    if (!Number.isFinite(n) || n <= 0) return 0;
    return Math.round(n * 100);
  }

  formatMoney(cents) {
    return FoxTheme.Currency.formatMoney(cents, FoxTheme.settings.moneyFormat);
  }

  // Both tariffs are always in the DOM; the price switch shows one or the other through
  // .bradano-price-pro / .bradano-price-public (see skill b2b-pricing). The pro price
  // carries the HT suffix, the public one is tax-included.
  renderDualPrice(proCents, publicCents) {
    const pro = `<span class="bradano-price-pro">${this.formatMoney(proCents)}<span class="excluding-taxes">HT</span></span>`;
    const pub = publicCents ? `<span class="bradano-price-public">${this.formatMoney(publicCents)}</span>` : '';

    return `${pro}${pub}`;
  }

  // Populates the "current product" card shown at the top of the pack step.
  setPackCurrentProduct(product = {}) {
    const imageEl = this.query('[data-pack-current-image]');
    const titleEl = this.query('[data-pack-current-title]');
    const variantEl = this.query('[data-pack-current-variant]');
    const priceEl = this.query('[data-pack-current-price]');

    const title = product.product_title || '';
    const variant = product.variant_title || '';
    const imageUrl = product.featured_image?.url || '';

    if (titleEl) titleEl.textContent = title;
    if (variantEl) variantEl.textContent = variant;
    // The public price is unknown at this point: it only arrives with the pack lookup, so
    // renderPackOptions refreshes this slot through setPackCurrentPublicPrice.
    if (priceEl) {
      priceEl.dataset.proPrice = Number(product.final_price) || 0;
      priceEl.innerHTML = this.renderDualPrice(product.final_price, null);
    }
    if (imageEl) {
      if (imageUrl) {
        imageEl.hidden = false;
        imageEl.src = imageUrl;
        imageEl.alt = title;
      } else {
        imageEl.hidden = true;
      }
    }
  }

  // Re-renders the current product card once the lookup has brought back its public price.
  setPackCurrentPublicPrice(publicCents) {
    const priceEl = this.query('[data-pack-current-price]');
    if (!priceEl) return;

    priceEl.innerHTML = this.renderDualPrice(Number(priceEl.dataset.proPrice) || 0, publicCents);
  }

  // Cart lines eligible to be paired with `newSku` inside the same contremarque:
  // same _contremarque property, not the line we just added, not a Pack line itself,
  // not a line of the same product family, with a usable SKU different from the one
  // just added. Deduped by SKU.
  getCandidateLines(cartItems, contremarqueValue, excludeKey, newSku, newProductType) {
    if (!contremarqueValue) return [];

    const normalizedNew = this.normalizeSku(newSku);
    const normalizedNewType = this.normalizeProductType(newProductType);
    const seen = new Set();
    const candidates = [];

    (cartItems || []).forEach((item) => {
      if (item.key === excludeKey) return;

      const itemType = this.normalizeProductType(item.product_type);
      if (itemType === this.packProductType) return;

      // A pack always pairs two different families (a cuve with a mitigeur), and the
      // Shopify product type is what carries that family. Two lines sharing a type can
      // never form a pack, so they must not reach the tag lookup at all: they would come
      // back empty and the step would wrongly report a missing pack to the customer.
      // Types are compared only when both are known — an empty type degrades to the
      // previous behaviour rather than silently dropping a legitimate candidate.
      if (normalizedNewType && itemType && itemType === normalizedNewType) return;

      if ((item.properties?.['_contremarque'] || '') !== contremarqueValue) return;

      const sku = this.normalizeSku(item.sku);
      if (!sku || sku === normalizedNew || seen.has(sku)) return;

      seen.add(sku);
      candidates.push(item);
    });

    return candidates;
  }

  // Builds the GraphQL `query` filter value covering every candidate SKU, in both
  // possible tag orders (the pack tag isn't guaranteed to always be cuve-then-mitigeur).
  // Expects raw (non-lowercased) SKUs — Shopify's tag: search is case-sensitive, and pack
  // tags are written with the SKU's real catalog casing.
  buildPackTagFilter(newSku, candidateSkus) {
    const clauses = [];
    candidateSkus.forEach((sku) => {
      clauses.push(`tag:'pack:${newSku}-${sku}'`);
      clauses.push(`tag:'pack:${sku}-${newSku}'`);
    });
    return clauses.join(' OR ');
  }

  // Shared transport. Returns `data` or null; a GraphQL error is never fatal for the
  // caller, which decides what to degrade.
  async graphql(document, variables, label) {
    try {
      const res = await fetch(`/api/${this.graphqlApiVersion}/graphql.json`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ query: document, variables }),
      });
      // Shopify never errors on a retired version: it falls forward to the oldest accessible
      // one and only says so in this header. Left unread, the day a breaking change lands in
      // that version the lookup returns nothing and every pack silently reads "unavailable".
      const servedVersion = res.headers.get('X-Shopify-API-Version');
      if (servedVersion && servedVersion !== this.graphqlApiVersion) {
        console.warn(
          `[pack step] API version ${this.graphqlApiVersion} is no longer served, Shopify answered as ${servedVersion} — bump graphqlApiVersion.`
        );
      }

      const json = await res.json();
      if (json.errors) {
        console.warn(`[pack step] ${label} GraphQL error:`, json.errors);
        return json.data || null;
      }
      return json.data || null;
    } catch (error) {
      console.warn(`[pack step] ${label} request failed:`, error);
      return null;
    }
  }

  // Storefront GraphQL request scoped to this contremarque's candidates — never the whole
  // pack catalog. Same-origin calls to /api/{version}/graphql.json need no access token.
  //
  // Never add a `metafield` field here: the tokenless client lacks the
  // `unauthenticated_read_metafields` scope, and Shopify then rejects the *whole* document,
  // so every pack would silently become "unavailable". Metafields go through Liquid
  // (see fetchPublicPrices).
  async fetchPacksByTag(tagQuery, first) {
    const document = `
      query PackLookup($query: String!, $first: Int!) {
        products(first: $first, query: $query) {
          edges {
            node {
              title
              handle
              tags
              featuredImage { url }
              variants(first: 1) {
                edges {
                  node {
                    id
                    availableForSale
                    price { amount }
                  }
                }
              }
            }
          }
        }
      }
    `;

    const data = await this.graphql(document, { query: tagQuery, first }, 'pack lookup');

    return data?.products?.edges?.map((edge) => edge.node) || [];
  }

  // Public prices, rendered by Liquid — never by GraphQL. The tokenless Storefront client
  // has no `unauthenticated_read_metafields` scope, so requesting a `metafield` field fails
  // the *entire* request ("Access denied for metafield field"), pack lookup included.
  //
  // The `pack-public-prices` section is fetched through the Section Rendering API bound to
  // the pack's handle, so one response carries both the pack's own public price (from the
  // bound `product`) and every cart line's (`cart` is readable from any Liquid context).
  // `packHandle` may be null: the section then renders the cart prices alone.
  //
  // @returns {Promise<{ packPublicPrice: number|null, cartPublicPrices: Map<string, number> }>}
  async fetchPublicPrices(packHandle = null) {
    this._publicPricesCache = this._publicPricesCache || new Map();
    const cacheKey = packHandle || '';
    if (this._publicPricesCache.has(cacheKey)) return this._publicPricesCache.get(cacheKey);

    const result = { packPublicPrice: null, cartPublicPrices: new Map() };
    const root = FoxTheme.routes.root_url.replace(/\/$/, '');
    const path = packHandle ? `${root}/products/${encodeURIComponent(packHandle)}` : `${root}/`;

    try {
      const res = await fetch(`${path}?section_id=pack-public-prices`);
      const html = await res.text();
      const payload = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-pack-public-prices]');
      const parsed = payload ? JSON.parse(payload.textContent || '{}') : {};

      result.packPublicPrice = this.toCents(parsed.product) || null;
      Object.entries(parsed.cart || {}).forEach(([sku, value]) => {
        const cents = this.toCents(value);
        const normalized = this.normalizeSku(sku);
        if (cents && normalized) result.cartPublicPrices.set(normalized, cents);
      });
    } catch (error) {
      console.warn('[pack step] public prices request failed:', error);
    }

    this._publicPricesCache.set(cacheKey, result);

    return result;
  }

  // Extracts the two SKUs from a tag shaped like: pack:SKU1-SKU2.
  getPackSkusFromTags(tags) {
    const list = Array.isArray(tags) ? tags : String(tags || '').split(',').map((t) => t.trim());
    const packTag = list.find((t) => /^pack:/i.test(t));
    if (!packTag) return null;

    return (packTag.split(':')[1]?.split('-') || []).map((sku) => this.normalizeSku(sku));
  }

  buildPackEntry(node) {
    const variant = node.variants?.edges?.[0]?.node;
    if (!variant) return null;

    // Storefront API variant ids are GIDs (gid://shopify/ProductVariant/123); the
    // trailing numeric segment is the same id /cart/add.js expects.
    const variantId = Number(variant.id?.split('/').pop());
    if (!Number.isFinite(variantId) || variantId <= 0) return null;

    const price = this.toCents(variant.price?.amount || 0);

    return {
      packVariantId: variantId,
      packTitle: node.title,
      // Addresses the Liquid section that holds the public price (see fetchPublicPrices).
      packHandle: node.handle || null,
      packPrice: price,
      // Filled in by findMatchingPacks. Stays null when unknown — never falls back on the
      // pro price, which would put a wrong amount in front of the customer.
      packPublicPrice: null,
      packAvailable: variant.availableForSale !== false,
      packImage: node.featuredImage?.url || null,
    };
  }

  // Matches candidate contremarque lines against real Pack products. Returns the confirmed
  // packs, each paired with the existing cart line it combines with, plus the SKU→public
  // price map the whole step renders from.
  async findMatchingPacks(newSku, candidates) {
    if (candidates.length === 0) return { matches: [], publicPrices: new Map() };

    const normalizedNew = this.normalizeSku(newSku);
    const candidateSkus = candidates.map((item) => item.sku);
    // Shopify's tag: search filter is case-sensitive, and pack tags are written with the
    // SKU's real casing (e.g. pack:A62570-A64637) — build the query from the raw SKUs, not
    // normalized/lowercased ones. Same for the variants.sku: filter.
    const tagQuery = this.buildPackTagFilter(newSku, candidateSkus);
    const nodes = await this.fetchPacksByTag(tagQuery, candidates.length);

    const results = [];
    nodes.forEach((node) => {
      const skus = this.getPackSkusFromTags(node.tags);
      if (!skus || skus.length !== 2 || !skus.includes(normalizedNew)) return;

      const complementarySku = skus.find((sku) => sku !== normalizedNew);
      const existingItem = candidates.find((item) => this.normalizeSku(item.sku) === complementarySku);
      if (!existingItem) return;

      const pack = this.buildPackEntry(node);
      if (pack) results.push({ pack, existingItem });
    });

    // Public prices come second, because the Liquid section is addressed by the pack's
    // handle — which only exists once the lookup has resolved. One request per confirmed
    // pack (in practice one), each also carrying the cart lines, so the radio switch stays
    // instant. Prices are cosmetic: a failure here leaves the step fully usable.
    const priceSets = await Promise.all(
      results.length ? results.map(({ pack }) => this.fetchPublicPrices(pack.packHandle)) : [this.fetchPublicPrices()]
    );
    results.forEach(({ pack }, index) => {
      pack.packPublicPrice = priceSets[index]?.packPublicPrice || null;
    });

    return { matches: results, publicPrices: priceSets[0]?.cartPublicPrices || new Map() };
  }

  // Discount percentage of a pack against what its components cost separately. Floored,
  // like the cart, so the figure is never rounded up in the customer's favour.
  getPackSavings(reference, packPrice) {
    if (!reference || !packPrice || reference <= packPrice) return 0;

    return Math.floor(((reference - packPrice) * 100) / reference);
  }

  renderSavingsBadge(percent, tariffClass) {
    const label = FoxTheme.contremarqueStrings.savePercent.replace('[percent]', percent);

    return `<span class="f-badge f-badge--sale ${tariffClass}">${FoxTheme.utils.escapeHtml(label)}</span>`;
  }

  // One tariff's price block: the pack price, struck through with the separate-purchase
  // reference when there is something saved.
  renderSuggestionPriceBlock(packPrice, reference, isOnSale, tariffClass, withTaxSuffix) {
    const suffix = withTaxSuffix ? '<span class="excluding-taxes">HT</span>' : '';
    const amount = `${this.formatMoney(packPrice)}${suffix}`;

    if (!isOnSale) {
      return `
        <div class="f-price ${tariffClass}">
          <div class="f-price__regular">
            <span class="f-price-item f-price-item--regular">${amount}</span>
          </div>
        </div>
      `;
    }

    return `
      <div class="f-price f-price--on-sale ${tariffClass}">
        <div class="f-price__sale">
          <span class="f-price-item f-price-item--sale">${amount}</span>
          <span class="f-price-item f-price-item--regular"><s>${this.formatMoney(reference)}</s></span>
        </div>
      </div>
    `;
  }

  // Renders the suggestion card for the selected pack option. Only ever called with a
  // confirmed pack: renderPackOptions skips the card entirely on a catalog gap, so the
  // hide branch below is a guard against a stale index, not a normal state.
  updatePackSuggestion(options, selectedIndex, currentProductData) {
    const divider = this.query('[data-pack-divider]');
    const suggestion = this.query('[data-pack-suggestion]');
    if (!divider || !suggestion) return;

    const option = options[selectedIndex];
    if (!option) {
      divider.hidden = true;
      suggestion.hidden = true;
      return;
    }

    const { pack, existingItem, currentPublicPrice, existingPublicPrice } = option;

    divider.hidden = false;
    suggestion.hidden = false;

    const titleEl = suggestion.querySelector('[data-pack-suggestion-title]');
    const colorsEl = suggestion.querySelector('[data-pack-suggestion-colors]');
    const badgeEl = suggestion.querySelector('[data-pack-suggestion-badge]');
    const priceEl = suggestion.querySelector('[data-pack-suggestion-price]');
    if (titleEl) titleEl.textContent = pack.packTitle || '';

    const price = Number(pack.packPrice || 0);
    const publicPrice = Number(pack.packPublicPrice) || 0;

    // Reference price = what the two products cost bought separately. A pack is always
    // cheaper than its components, and it carries no compare at price — so the discount is
    // derived, exactly like a pack line in the cart (see `line_compare_price` in
    // main-cart.liquid). Computed per tariff: the pro and public discounts differ.
    const proReference = (Number(currentProductData?.final_price) || 0) + (Number(existingItem.price) || 0);
    const publicReference = (Number(currentPublicPrice) || 0) + (Number(existingPublicPrice) || 0);
    // A partial reference (one component without a public price) would understate the
    // discount, so it is dropped entirely rather than shown wrong.
    const hasPublicReference = Boolean(currentPublicPrice && existingPublicPrice && publicPrice);

    const currentColor =
      currentProductData?.variant_title && !/default title/i.test(currentProductData.variant_title)
        ? currentProductData.variant_title.trim()
        : '';
    const complementaryColor =
      existingItem.variant_title && !/default title/i.test(existingItem.variant_title)
        ? existingItem.variant_title.trim()
        : '';
    const suggestionColors = currentColor && complementaryColor ? `${currentColor}, ${complementaryColor}` : '';

    if (colorsEl) {
      if (suggestionColors) {
        colorsEl.textContent = suggestionColors;
        colorsEl.classList.remove('hidden');
      } else {
        colorsEl.textContent = '';
        colorsEl.classList.add('hidden');
      }
    }

    const proSavings = this.getPackSavings(proReference, price);
    const publicSavings = hasPublicReference ? this.getPackSavings(publicReference, publicPrice) : 0;

    if (badgeEl) {
      // One badge per tariff, both in the DOM: the price switch is CSS-only, so the pro and
      // public discounts must coexist rather than be recomputed when the mode changes.
      const badges = [
        proSavings ? this.renderSavingsBadge(proSavings, 'bradano-price-pro') : '',
        publicSavings ? this.renderSavingsBadge(publicSavings, 'bradano-price-public') : '',
      ].join('');

      badgeEl.innerHTML = badges;
      badgeEl.classList.toggle('hidden', badges === '');
    }

    if (priceEl) {
      // Two independent blocks rather than one with interleaved spans: each tariff has its
      // own on-sale state, and `.f-price--on-sale` lives on the wrapper.
      const proBlock = this.renderSuggestionPriceBlock(price, proReference, proSavings > 0, 'bradano-price-pro', true);
      const publicBlock = publicPrice
        ? this.renderSuggestionPriceBlock(publicPrice, publicReference, publicSavings > 0, 'bradano-price-public', false)
        : '';

      priceEl.innerHTML = `${proBlock}${publicBlock}`;
    }

    const imgCurrent = suggestion.querySelector('[data-pack-suggestion-img-current]');
    const topCardImg = this.query('[data-pack-current-image]');
    const currentImageUrl =
      currentProductData?.featured_image?.url ||
      (topCardImg && !topCardImg.hidden ? topCardImg.src : '') ||
      '';
    if (imgCurrent) {
      if (currentImageUrl) {
        imgCurrent.src = currentImageUrl;
        imgCurrent.alt = currentProductData?.product_title || '';
        imgCurrent.hidden = false;
      } else {
        imgCurrent.hidden = true;
      }
    }

    const imgComplementary = suggestion.querySelector('[data-pack-suggestion-img-complementary]');
    const complementaryImageUrl = existingItem.featured_image?.url || '';
    if (imgComplementary) {
      if (complementaryImageUrl) {
        imgComplementary.src = complementaryImageUrl;
        imgComplementary.alt = existingItem.product_title || '';
        imgComplementary.hidden = false;
      } else {
        imgComplementary.hidden = true;
      }
    }
  }

  renderPackOptionPrice(priceInCents, publicPriceInCents) {
    const price = Number(priceInCents || 0);
    if (!price) return '';

    return `<div class="drawer__pack-product-price font-body-bolder">${this.renderDualPrice(price, publicPriceInCents)}</div>`;
  }

  async renderPackOptions(sku, currentProductData, cartItems, contremarqueValue, excludeKey) {
    const container = this.query('[data-pack-options]');
    if (!container) return 0;

    const divider = this.query('[data-pack-divider]');
    const suggestion = this.query('[data-pack-suggestion]');
    const unavailable = this.query('[data-pack-unavailable]');
    const combineButton = this.query('[data-pack-combine]');
    const error = this.query('[data-pack-error-message]');
    if (divider) divider.hidden = true;
    if (suggestion) suggestion.hidden = true;
    if (unavailable) unavailable.hidden = true;
    if (combineButton) combineButton.disabled = false;
    if (error) {
      error.hidden = true;
      error.innerText = '';
    }

    // currentProductData is the /cart/add.js line of the product just added; its
    // product_type is the family the candidates are filtered against.
    const candidates = this.getCandidateLines(cartItems, contremarqueValue, excludeKey, sku, currentProductData?.product_type);
    if (candidates.length === 0) {
      container.innerHTML = '';
      return 0;
    }

    container.innerHTML = `<span class="text-sm text-subtext">${FoxTheme.utils.escapeHtml(FoxTheme.contremarqueStrings.packSearching)}</span>`;

    const { matches, publicPrices } = await this.findMatchingPacks(sku, candidates);
    // A sold-out pack must not be offered: combining would drop the two source lines in
    // exchange for an add-to-cart that Shopify rejects. Treat it as a catalog gap instead.
    const confirmed = matches.filter(({ pack }) => pack.packAvailable);
    container.innerHTML = '';

    const currentPublicPrice = publicPrices.get(this.normalizeSku(sku));
    this.setPackCurrentPublicPrice(currentPublicPrice);

    const isAvailable = confirmed.length > 0;
    // No real Pack product exists yet for these candidates (catalog gap) — still preview
    // each candidate line in the options list (using its own cart data) rather than silently
    // skipping the step, but non-actionable: no suggestion card, just the subtext below.
    // Each option carries the two component public prices, which the suggestion card needs
    // to derive the public discount without reaching back into the lookup.
    const options = isAvailable
      ? confirmed.map((entry) => ({
          ...entry,
          currentPublicPrice,
          existingPublicPrice: publicPrices.get(this.normalizeSku(entry.existingItem.sku)),
        }))
      : candidates.map((existingItem) => ({ pack: null, existingItem }));

    options.forEach(({ pack, existingItem }, index) => {
      const title = FoxTheme.utils.escapeHtml(existingItem.product_title || '');
      const imageUrl = existingItem.featured_image?.url || '';
      const complementaryPriceHtml = this.renderPackOptionPrice(
        existingItem.price || 0,
        publicPrices.get(this.normalizeSku(existingItem.sku))
      );
      const media = imageUrl
        ? `<img class="w-full h-full object-cover" width="48" height="48" src="${FoxTheme.utils.escapeHtml(imageUrl)}" alt="${title}">`
        : '';

      const label = document.createElement('label');
      label.className = 'cart-drawer__purchaseflow-option flex gap-3 items-center rounded-md border p-2';
      label.setAttribute('data-pack-option', '');
      label.dataset.existingLineKey = existingItem.key;
      label.dataset.existingLineQty = existingItem.quantity;
      label.innerHTML = `
        <input type="radio" name="pack-choice" class="m-2" value="${pack?.packVariantId || ''}" ${index === 0 ? 'checked' : ''} ${isAvailable ? '' : 'disabled'}/>
        <div class="cart-item__media blocks-radius media-wrapper drawer__pack-thumb" aria-hidden="true">
          ${media}
        </div>
        <div class="flex flex-row justify-between items-center w-full">
          <div class="flex flex-col">
            <div class="drawer__pack-product-title">${title}</div>
          </div>
          ${complementaryPriceHtml}
        </div>
      `;
      container.appendChild(label);
    });

    if (combineButton) combineButton.disabled = !isAvailable;

    if (!isAvailable) {
      if (divider) divider.hidden = false;
      if (unavailable) unavailable.hidden = false;
      return options.length;
    }

    this.updatePackSuggestion(options, 0, currentProductData);

    if (this._onPackOptionChange) {
      container.removeEventListener('change', this._onPackOptionChange);
    }
    this._onPackOptionChange = (e) => {
      const radio = e.target.closest('input[type="radio"]');
      if (!radio) return;
      const selectedIndex = options.findIndex(({ pack }) => String(pack.packVariantId) === radio.value);
      if (selectedIndex >= 0) {
        this.updatePackSuggestion(options, selectedIndex, currentProductData);
      }
    };
    container.addEventListener('change', this._onPackOptionChange);

    return options.length;
  }
}

class PurchaseFlowDrawer extends DrawerComponent {
  constructor() {
    super();
    this.session = null;
    this.currentStep = null;
    this.packStepController = new PackStepController(this);
  }

  // Already rendered at body level by the layout — don't relocate on open.
  get requiresBodyAppended() {
    return false;
  }

  // Used by ProductForm's guard: only hijack add-to-cart if the drawer is usable.
  get isReady() {
    return this.isConnected && this.steps.length > 0;
  }

  get sectionId() {
    return this.getAttribute('data-section-id');
  }

  get steps() {
    return Array.from(this.querySelectorAll('[data-step]'));
  }

  get titleElement() {
    return this.querySelector('[data-flow-title]');
  }

  get backButton() {
    return this.querySelector('[data-flow-back]');
  }

  get headerMain() {
    return this.querySelector('.drawer__header-main');
  }

  get defaultTitle() {
    return this._defaultTitle || this.titleElement?.textContent?.trim() || '';
  }

  getStepTitle(name) {
    if (name === 'pack') return FoxTheme.contremarqueStrings.packStepTitle;
    return this.defaultTitle;
  }

  connectedCallback() {
    super.connectedCallback();
    this._defaultTitle = this.titleElement?.textContent?.trim() || '';

    this.backButton?.addEventListener(
      'click',
      async () => {
        await this.handleBackToContremarque();
      },
      { signal: this.abortController.signal }
    );
  }

  handleBackToContremarque = async () => {
    if (this.currentStep === 'pack') {
      const sourceForm =
        this.session?.sourceForm ||
        window.FoxThemeContremarqueSourceForm ||
        document.querySelector('form[is="product-form"]');

      if (sourceForm?.isAwaitingPackDecision && typeof sourceForm.cancelPendingSimpleProduct === 'function') {
        await sourceForm.cancelPendingSimpleProduct();
      }
    }

    this.goToStep('contremarque');
  }

  updateHeader(name) {
    if (this.titleElement) {
      this.titleElement.textContent = this.getStepTitle(name);
    }

    if (this.backButton) {
      this.backButton.hidden = name !== 'pack';
    }

    this.headerMain?.classList.toggle('is-back-visible', name === 'pack');
  }

  // Show a single step panel, hide the others.
  goToStep(name) {
    let matched = false;
    this.steps.forEach((panel) => {
      const isTarget = panel.dataset.step === name;
      panel.toggleAttribute('hidden', !isTarget);
      if (isTarget) matched = true;
    });
    if (matched) {
      this.currentStep = name;
      this.updateHeader(name);
    }
    return matched;
  }

  // Entry point: receives the purchase session, resets to step 1, opens.
  // NB: named openFlow (not open) to avoid shadowing ModalComponent's `get open()`.
  openFlow(session = {}) {
    this.session = session;
    this.goToStep('contremarque');
    this.show(session.sourceElement || null);
  }

  // The two entry points ProductForm needs; everything else stays internal to the controller.
  setPackCurrentProduct(product = {}) {
    return this.packStepController.setPackCurrentProduct(product);
  }

  async renderPackOptions(sku, currentProductData, cartItems, contremarqueValue, excludeKey) {
    return this.packStepController.renderPackOptions(sku, currentProductData, cartItems, contremarqueValue, excludeKey);
  }
}
customElements.define('purchase-flow-drawer', PurchaseFlowDrawer);

// Purchase flow drawer listeners for products
const attachPurchaseFlowDrawerGlobalListeners = () => {
  if (window.FoxThemePurchaseFlowDrawerListenersAttached) return;

  const flowDrawer = document.querySelector('purchase-flow-drawer');
  if (flowDrawer && flowDrawer.dataset.packCancelBound !== 'true') {
    flowDrawer.addEventListener('drawer:handleAfterHide', () => {
      const form = window.FoxThemeContremarqueSourceForm || document.querySelector('form[is="product-form"]');
      form?.cancelPendingPackFlowIfNeeded?.();
    });
    flowDrawer.dataset.packCancelBound = 'true';
  }

  document.addEventListener('click', (event) => {
    const confirmContremarqueButton = event.target.closest('[data-contremarque-confirm]');
    if (confirmContremarqueButton) {
      event.preventDefault();

      const form = window.FoxThemeContremarqueSourceForm || document.querySelector('form[is="product-form"]');
      if (form && typeof form.confirmContremarque === 'function') {
        form.confirmContremarque(confirmContremarqueButton);
      }
      return;
    }

    const combineButton = event.target.closest('[data-pack-combine]');
    if (combineButton) {
      event.preventDefault();
      const form = window.FoxThemeContremarqueSourceForm || document.querySelector('form[is="product-form"]');
      if (form && typeof form.combineWithPack === 'function') {
        form.combineWithPack(combineButton);
      }
      return;
    }

    const skipCombineButton = event.target.closest('[data-pack-no-combine]');
    if (!skipCombineButton) return;

    event.preventDefault();

    const form = window.FoxThemeContremarqueSourceForm || document.querySelector('form[is="product-form"]');
    if (form && typeof form.skipPackCombination === 'function') {
      form.skipPackCombination();
    }
  });

  // Picking an existing contremarque and creating a new one are mutually exclusive.
  // Selecting a history radio clears the "create" field instead of pre-filling it.
  document.addEventListener('change', (event) => {
    const radio = event.target.closest('[data-contremarque-option] input[type="radio"]');
    if (!radio || !radio.checked) return;

    const input = document.querySelector('[data-contremarque-input]');
    if (input) input.value = '';

    const form = window.FoxThemeContremarqueSourceForm || document.querySelector('form[is="product-form"]');
    form?.refreshContremarqueConfirmState?.();
  });

  // Epilogue: when the purchase flow completes, close the drawer and confirm via toast.
  document.addEventListener('purchase-flow:complete', (event) => {
    const drawer = document.querySelector('purchase-flow-drawer');
    const message = event.detail?.message || FoxTheme.contremarqueStrings.productAddedGeneric;
    const showToast = () =>
      FoxTheme.toast(message, {
        type: 'positive',
        link: { label: FoxTheme.contremarqueStrings.viewCart, href: FoxTheme.routes.cart_url },
      });

    if (drawer && drawer.open) {
      drawer.hide().then(showToast);
    } else {
      showToast();
    }
  });

  window.FoxThemePurchaseFlowDrawerListenersAttached = true;
};

/**
 * Customized built-in <form is="product-form">. Binding, in 3 pieces:
 *  1. Liquid declares the form: `{% form 'product', ..., is: 'product-form' %}` (buy-buttons.liquid:43).
 *  2. `customElements.define('product-form', ProductForm, { extends: 'form' })` registers this class
 *     under the key `product-form` — the form's `is=` value matching that key is what links the two.
 *  3. On upgrade, the constructor binds the form's native `submit` event to `handleFormSubmit`
 *     (fired by the add-to-cart button / Enter), which runs the AJAX add-to-cart flow.
 */
class ProductForm extends HTMLFormElement {
  constructor() {
    super();

    this.productIdInput = this.querySelector('[name=id]');
    this.productIdInput.disabled = false;
    this.pendingPurchaseState = null;
    this.isAwaitingPackDecision = false;
    this.isCancellingPendingPack = false;
    this.packActionButtonElement = null;
    // Native form `submit` → handleFormSubmit (see class doc).
    this.addEventListener('submit', this.handleFormSubmit);
    attachPurchaseFlowDrawerGlobalListeners();
  }

  get cartDrawerElement() {
    return document.querySelector('cart-drawer');
  }

  // Dedicated funnel drawer (contremarque → pack → add).
  get flowDrawerElement() {
    return document.querySelector('purchase-flow-drawer');
  }

  get submitButtonElement() {
    return (this._submitButtonElement = this._submitButtonElement || this.querySelector('[type="submit"]'));
  }

  get isHideErrors() {
    return this.dataset.hideErrors === 'true';
  }

  get isPackEligible() {
    return this.dataset.packEligible === 'true';
  }

  cancelPendingPackFlowIfNeeded = async () => {
    if (!this.isAwaitingPackDecision || this.isCancellingPendingPack) return;

    const drawer = this.flowDrawerElement;
    if (drawer?.currentStep !== 'pack') return;

    await this.cancelPendingSimpleProduct();
  };

  cancelPendingSimpleProduct = async () => {
    const state = this.pendingPurchaseState;
    const removedQuantity = this.lastAddedQuantity || 1;

    if (!state?.key) {
      this.pendingPurchaseState = null;
      this.isAwaitingPackDecision = false;
      return;
    }

    this.isCancellingPendingPack = true;
    try {
      const remaining = Math.max(0, (Number(state.quantity) || 0) - removedQuantity);
      await fetch(FoxTheme.routes.cart_change_url, {
        ...FoxTheme.utils.fetchConfig('json'),
        body: JSON.stringify({ id: state.key, quantity: remaining }),
      });

      const cartJson = await (
        await fetch(`${FoxTheme.routes.cart_url}`, { ...FoxTheme.utils.fetchConfig('json', 'GET') })
      ).json();
      this.updateCartState(cartJson);
    } catch (error) {
      console.log(error);
    } finally {
      this.pendingPurchaseState = null;
      this.isAwaitingPackDecision = false;
      this.isCancellingPendingPack = false;
      this._confirmedContremarqueValue = null;
    }
  };

  /**
  * Handler for the form's native `submit` event (see class doc above).
  * @param {SubmitEvent} event - `event.submitter` is the clicked add-to-cart button.
  */
  handleFormSubmit = async (event) => {
    if (FoxTheme.settings.cartType === 'page') return;

    // Robustness guard: if the funnel drawer isn't usable, don't trap the user —
    // let the form submit natively (degraded fallback) rather than block add-to-cart.
    const drawer = this.flowDrawerElement;
    if (!drawer || !drawer.isReady) return;

    event.preventDefault();
    if (this.submitButtonElement.getAttribute('aria-disabled') === 'true') return;

    this.lastSubmittedElement = event.submitter || event.currentTarget;
    window.FoxThemeContremarqueSourceForm = this;
    this.displayFormErrors();

    await this.openContremarqueStep(drawer);
  };

  buildAddToCartConfig = () => {
    let sectionsToBundle = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
    );

    const config = FoxTheme.utils.fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    this.formData = new FormData(this);
    this.lastAddedQuantity = Number(this.formData.get('quantity')) || 1;

    const contremarqueValue = this.getContremarqueValue();
    if (contremarqueValue) {
      this._confirmedContremarqueValue = contremarqueValue; // Persist before history re-render clears radio state.
      this.saveContremarqueToLocalStorage(contremarqueValue);
      this.formData.set('properties[_contremarque]', contremarqueValue);
    }

    this.formData.append('sections', sectionsToBundle);
    this.formData.append('sections_url', window.location.pathname);

    config.body = this.formData;
    return config;
  };

  // A checked history radio (existing contremarque) takes precedence over the
  // free-text "create" field; the two are mutually exclusive.
  getContremarqueValue = () => {
    const drawer = this.flowDrawerElement;
    const checkedRadio = drawer?.querySelector('[data-contremarque-option] input[type="radio"]:checked');
    if (checkedRadio) return checkedRadio.value.trim();
    return drawer?.querySelector('[data-contremarque-input]')?.value?.trim() || '';
  };

  // "Créer" is enabled only when the text field has content; "Associer" only when
  // a history radio is checked. Mutual exclusivity means at most one is active.
  refreshContremarqueConfirmState = () => {
    const drawer = this.flowDrawerElement;
    if (!drawer) return;
    const hasText = !!drawer.querySelector('[data-contremarque-input]')?.value.trim();
    const hasRadio = !!drawer.querySelector('[data-contremarque-option] input[type="radio"]:checked');
    drawer.querySelectorAll('[data-contremarque-create]').forEach((btn) => (btn.disabled = !hasText));
    drawer.querySelectorAll('[data-contremarque-assign]').forEach((btn) => (btn.disabled = !hasRadio));
  };

  saveContremarqueToLocalStorage = (value) => {
    if (!value) return;

    const storageKey = 'bradano:contremarques';
    const storageDaysDuration = 21;

    const previousContremarqueStorageState = FoxTheme.utils.getStorage(storageKey) || [];
    const updatedContremarqueStorageState = [value, ...previousContremarqueStorageState.filter((item) => item !== value)];

    FoxTheme.utils.setStorage(storageKey, updatedContremarqueStorageState, storageDaysDuration);
    this.renderContremarqueDrawerHistory(updatedContremarqueStorageState);
  };

  /**
   * Renders the contremarque history inside the cart drawer.
   *
   * @param {Array<string>|null} paramContremarques - Optional array of contremarque strings.
   *        If omitted, the function reads from local storage (`'bradano:contremarques'`).
   */
  renderContremarqueDrawerHistory = (paramContremarques = null) => {
    const drawer = this.flowDrawerElement;
    const historyContainer = drawer?.querySelector('[data-contremarque-history]');

    if (!historyContainer) return;

    const contremarques = paramContremarques || FoxTheme.utils.getStorage('bradano:contremarques') || [];

    if (!contremarques.length) {
      historyContainer.innerHTML = `
        <span class="text-sm text-subtext">${FoxTheme.contremarqueStrings.emptyHistory}</span>
      `;
      return;
    }

    historyContainer.classList.remove('hidden');
    historyContainer.innerHTML = contremarques
      .map((value) => {
        const safeValue = FoxTheme.utils.escapeHtml(value);

        return `
          <label class="cart-drawer__purchaseflow-option flex gap-2 rounded-md border p-2" data-contremarque-option>
            <input type="radio" name="contremarque-history" value="${safeValue}" />
            <span class="text-sm">${safeValue}</span>
          </label>
        `;
      })
      .join('');
  };

  confirmContremarque = (triggerButton = null) => {
    const value = this.getContremarqueValue();

    if (!value) return;

    const config = this.buildAddToCartConfig();

    this.flowConfirmButtonElement = triggerButton;
    if (this.flowConfirmButtonElement) {
      this.flowConfirmButtonElement.setAttribute('aria-disabled', 'true');
      this.flowConfirmButtonElement.classList.add('btn--loading');
    }

    this.submitButtonElement.setAttribute('aria-disabled', 'true');
    this.submitButtonElement.classList.add('btn--loading');

    this.handleFormSubmission(config);
  };

  getPackSelectionVariantId = () => {
    const drawer = this.flowDrawerElement;
    const checkedRadio = drawer?.querySelector('[data-pack-option] input[type="radio"]:checked');
    const variantId = Number(checkedRadio?.value);

    return Number.isFinite(variantId) && variantId > 0 ? variantId : null;
  };

  // The existing contremarque line the checked pack option combines with.
  getPackSelectionExistingLine = () => {
    const drawer = this.flowDrawerElement;
    const checkedOption = drawer?.querySelector('[data-pack-option] input[type="radio"]:checked')?.closest('[data-pack-option]');
    const key = checkedOption?.dataset.existingLineKey;

    return key ? { key, quantity: Number(checkedOption.dataset.existingLineQty) || 0 } : null;
  };

  buildPackAddToCartConfig = (variantId, quantity = 1) => {
    let sectionsToBundle = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
    );

    const config = FoxTheme.utils.fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';

    const item = { id: variantId, quantity };
    const contremarqueValue = this._confirmedContremarqueValue || this.getContremarqueValue();
    if (contremarqueValue) {
      item.properties = { _contremarque: contremarqueValue };
    }

    config.body = JSON.stringify({
      sections: sectionsToBundle,
      sections_url: window.location.pathname,
      items: [item],
    });

    return config;
  };

  setPackActionLoading = (triggerButton = null) => {
    this.clearPackActionLoading();
    this.packActionButtonElement = triggerButton;
    if (!this.packActionButtonElement) return;

    this.packActionButtonElement.setAttribute('aria-disabled', 'true');
    this.packActionButtonElement.classList.add('btn--loading');
  };

  clearPackActionLoading = () => {
    if (!this.packActionButtonElement) return;

    this.packActionButtonElement.classList.remove('btn--loading');
    this.packActionButtonElement.removeAttribute('aria-disabled');
    this.packActionButtonElement = null;
  };

  // "Ajouter sans combiner" — keep the already-added individual product, close the flow.
  skipPackCombination = () => {
    this.isAwaitingPackDecision = false;
    this.completePurchaseFlow(this.pendingPurchaseState || {});
  };

  fetchCartState = async () => {
    try {
      const response = await fetch(`${FoxTheme.routes.cart_url}`, { ...FoxTheme.utils.fetchConfig('json', 'GET') });
      return await response.json();
    } catch (error) {
      console.log(error);
      return null;
    }
  };

  // "Combiner" — swap the just-added individual line for the chosen pack product.
  combineWithPack = async (triggerButton = null) => {
    this.setPackActionLoading(triggerButton);
    this.displayFormErrors(false, { usePackError: true });

    const packVariantId = this.getPackSelectionVariantId();
    if (!packVariantId) {
      this.skipPackCombination();
      return;
    }

    const state = this.pendingPurchaseState;
    const addedQuantity = this.lastAddedQuantity || 1;
    const existingLine = this.getPackSelectionExistingLine();

    // Order matters: add the pack FIRST, and only drop the two source lines once it is
    // actually in the cart. Dropping them upfront leaves the customer with an empty
    // contremarque whenever the pack add fails (sold out, quantity rule, network error).
    const config = this.buildPackAddToCartConfig(packVariantId, addedQuantity);
    const packState = await this.addPackToCart(config);
    if (!packState) return; // Error already shown in the pack step; the cart is untouched.

    this.isAwaitingPackDecision = false;

    // Both source lines go out in a single /cart/update.js call, not two.
    const updates = {};
    if (state?.key) {
      updates[state.key] = Math.max(0, (Number(state.quantity) || 0) - addedQuantity);
    }
    if (existingLine?.key) {
      updates[existingLine.key] = 0;
    }

    if (Object.keys(updates).length > 0) {
      await fetch(FoxTheme.routes.cart_update_url, {
        ...FoxTheme.utils.fetchConfig('json'),
        body: JSON.stringify({ updates }),
      }).catch((error) => console.log(error));
    }

    const cartJson = await this.fetchCartState();
    if (cartJson) {
      cartJson['sections'] = packState['sections'];
      this.updateCartState(cartJson);
    }

    // /cart/add.js answers `{ items: [line] }` when posted an `items` array, so unwrap
    // it before handing a line item to the toast / analytics consumers.
    const packLine = packState.items?.[0] || packState;
    this.dispatchProductAddedEvent(packLine);
    this.completePurchaseFlow(packLine);
  };

  /**
   * Adds the chosen pack line to the cart.
   * @returns {Promise<Object|null>} the /cart/add.js payload, or null when the add failed
   *   (the error is surfaced inside the pack step and no cart line has been touched).
   */
  addPackToCart = async (config) => {
    try {
      const response = await fetch(`${FoxTheme.routes.cart_add_url}`, config);
      const parsedState = await response.json();

      if (parsedState.status) {
        this.clearPackActionLoading();
        this.handleCartError(parsedState, { usePackError: true });
        const cartJson = await this.fetchCartState();
        if (cartJson) this.updateCartState(cartJson);
        return null;
      }

      return parsedState;
    } catch (error) {
      console.log(error);
      this.clearPackActionLoading();
      this.displayFormErrors(FoxTheme.contremarqueStrings.packAddFailed, { usePackError: true });
      return null;
    }
  };

  openContremarqueStep = async (drawer) => {
    const quickViewModal = this.closest('quick-view-modal');
    if (quickViewModal && quickViewModal.open) {
      await quickViewModal.hide();
    }

    this.renderContremarqueDrawerHistory();
    this.bindContremarqueInput(drawer);

    drawer.openFlow({ sourceForm: this, sourceElement: this.lastSubmittedElement });
  };

  // Typing a new contremarque deselects any chosen history radio (mutual exclusivity);
  // confirm buttons follow the resolved value via refreshContremarqueConfirmState.
  bindContremarqueInput = (drawer) => {
    const input = drawer.querySelector('[data-contremarque-input]');
    if (!input) return;

    if (!input.dataset.contremarqueBound) {
      input.addEventListener('input', () => {
        if (input.value.trim()) {
          drawer.querySelectorAll('[data-contremarque-option] input[type="radio"]:checked').forEach((radio) => {
            radio.checked = false;
          });
        }
        this.refreshContremarqueConfirmState();
      });
      input.dataset.contremarqueBound = 'true';
    }
    this.refreshContremarqueConfirmState();
  };

  displayFormErrors = (errorMessage = false, options = {}) => {
    if (this.isHideErrors) return;

    // Each funnel step owns its error slot: writing into the contremarque one while the
    // pack step is showing would put the message inside a hidden panel.
    let errorEl;
    if (options.usePackError === true) {
      errorEl = this.flowDrawerElement?.querySelector('[data-pack-error-message]');
    } else if (options.useDrawerError === true) {
      errorEl = this.flowDrawerElement?.querySelector('[data-contremarque-error-message]');
    } else {
      errorEl = this.formErrorMessage = this.formErrorMessage || this.querySelector('.product-form__error-message');
    }

    if (!errorEl) {
      if (errorMessage !== false) alert(errorMessage);
    } else {
      errorEl.toggleAttribute('hidden', !errorMessage);
      if (errorMessage !== false) errorEl.innerText = errorMessage;
    }
  };

  resetFormState() {
    this.hasError = false;
    this.submitButtonElement.removeAttribute('aria-disabled');
    this.displayFormErrors();
  }

  handleFormSubmission = (config) => {
    // Send a POST request to add an item to the cart.
    fetch(`${FoxTheme.routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then(async (parsedState) => {
        if (parsedState.status) {
          // Error (e.g. out of stock): show it inline in the drawer and keep it open.
          this.handleCartError(parsedState);
          const cartJsonSub = await (
            await fetch(`${FoxTheme.routes.cart_url}`, { ...FoxTheme.utils.fetchConfig('json', 'GET') })
          ).json();
          this.updateCartState(cartJsonSub);
          return;
        }

        // Success – refresh the cart silently so it's up to date on next open,
        // then hand off to the epilogue (close drawer + toast) instead of showing it.
        const cartJson = await (
          await fetch(`${FoxTheme.routes.cart_url}`, { ...FoxTheme.utils.fetchConfig('json', 'GET') })
        ).json();
        cartJson['sections'] = parsedState['sections'];

        this.pendingPurchaseState = parsedState;
        this.updateCartState(cartJson);
        this.dispatchProductAddedEvent(parsedState);

        const flowDrawer = this.flowDrawerElement;
        if (flowDrawer && this.isPackEligible) {
          // Set current product first so its image is in the DOM when the
          // suggestion card is rendered inside renderPackOptions.
          flowDrawer.setPackCurrentProduct?.(parsedState);
          const contremarqueValue = parsedState.properties?.['_contremarque'] || '';
          const matchingPacks =
            (await flowDrawer.renderPackOptions?.(
              parsedState.sku,
              parsedState,
              cartJson.items,
              contremarqueValue,
              parsedState.key
            )) || 0;
          if (matchingPacks > 0) {
            if (flowDrawer.goToStep('pack')) {
              this.isAwaitingPackDecision = true;
              return;
            }
          }
        }

        this.completePurchaseFlow(parsedState);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        // Remove loading spinner.
        this.submitButtonElement.classList.remove('btn--loading');
        this.submitButtonElement.removeAttribute('aria-disabled'); // Keep working with sticky ATC minimalist.

        if (this.flowConfirmButtonElement) {
          this.flowConfirmButtonElement.classList.remove('btn--loading');
          this.flowConfirmButtonElement.removeAttribute('aria-disabled');
          this.flowConfirmButtonElement = null;
        }
      });
  };

  handleCartError = (parsedState, options = { useDrawerError: true }) => {
    FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartError, {
      source: 'product-form',
      productVariantId: this.formData.get('id'),
      errors: parsedState.errors || parsedState.description,
      message: parsedState.message,
    });
    this.displayFormErrors(parsedState.description, options);
    document.dispatchEvent(
      new CustomEvent('product-ajax:error', {
        detail: {
          errorMessage: parsedState.description,
        },
      })
    );
    this.hasError = true;
  };

  updateCartState = (cartJson) => {
    FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cartJson });
  };

  dispatchProductAddedEvent = (parsedState) => {
    document.dispatchEvent(
      new CustomEvent('product-ajax:added', {
        detail: {
          product: parsedState,
        },
      })
    );
  };

  /**
   * Dispatches a custom event indicating that the purchase flow has completed.
   *
   * @param {Object} parsedState - The state object containing product information.
   * @param {string} [parsedState.product_title] - Title of the product (if available).
   * @param {string} [parsedState.title] - Alternative title for the product.
   * @param {string} [parsedState.variant_title] - Variant title, used unless it is a default title.
   * @param {number|string} [parsedState.quantity] - Quantity of items added to the cart.
   *
   * @fires CustomEvent#purchase-flow:complete
   *   This event bubbles and contains a `detail` object with:
   *   - `message`: A human‑readable confirmation message.
   *   - `parsedState`: The original state passed to this function.
   */
  completePurchaseFlow = (parsedState) => {
    window.FoxThemeContremarqueSourceForm = null;
    this._confirmedContremarqueValue = null;
    this.pendingPurchaseState = null;
    this.isAwaitingPackDecision = false;
    this.isCancellingPendingPack = false;
    this.clearPackActionLoading();

    const productTitle = parsedState?.product_title || parsedState?.title || '';
    const variantTitle =
      parsedState?.variant_title && !/default title/i.test(parsedState.variant_title)
        ? ` ${parsedState.variant_title}`
        : '';
    const quantity = parsedState?.quantity ? ` (${parsedState.quantity})` : '';
    const productLabel = `${productTitle}${variantTitle}${quantity}`;
    const message = productTitle
      ? FoxTheme.contremarqueStrings.productAdded.replace('[product]', productLabel)
      : FoxTheme.contremarqueStrings.productAddedGeneric;

    document.dispatchEvent(
      new CustomEvent('purchase-flow:complete', {
        bubbles: true,
        detail: { message, parsedState },
      })
    );
  };

  showCartDrawer = () => {
    const quickViewModal = this.closest('quick-view-modal');
    if (quickViewModal) {
      if (this.cartDrawerElement && !this.cartDrawerElement.open) {
        document.body.addEventListener(
          quickViewModal.events.handleAfterHide,
          () => {
            setTimeout(() => {
              this.cartDrawerElement.show(this.lastSubmittedElement);
            });
          },
          { once: true }
        );
      }

      quickViewModal.hide(true);
    } else {
      this.cartDrawerElement && this.cartDrawerElement.show(this.lastSubmittedElement);
    }
  };
}
customElements.define('product-form', ProductForm, { extends: 'form' });

class NewsletterForm extends HTMLFormElement {
  constructor() {
    super();

    this.selectors = {
      subscribedMessage: '[id*=Newsletter-error-subscribed]',
      modal: '[id*=NewsletterAlertModal-]',
    };

    this.init();
  }

  /**
   * Show message when user re-subscribe with exists email.
   */
  init() {
    const liveUrl = window.location.href;
    const result = liveUrl.includes('form_type=customer');
    const inputVal = this.querySelector('[id*="NewsletterForm"]').value.length;
    const modalEl = this.querySelector(this.selectors.modal);

    if (result && inputVal != 0) {
      const messageElement = this.querySelector(this.selectors.subscribedMessage);
      messageElement && messageElement.classList.remove('hidden');
      if (!window.isNewsletterModalShow) {
        modalEl && modalEl.show();
        window.isNewsletterModalShow = true;
      }
    }

    const alertEl = this.querySelector('.form-message--main');
    if (alertEl) {
      if (!window.isNewsletterModalShow) {
        modalEl && modalEl.show();
        window.isNewsletterModalShow = true;
      }
    }
  }
}
customElements.define('newsletter-form', NewsletterForm, { extends: 'form' });

class ColorSwatch extends HTMLUListElement {
  constructor() {
    super();

    this.selectors = {
      card: '.product-card',
      mainImg: '.product-card__image--main img',
      swatches: '.swatch-item',
      variantImg: '.color-swatch--variant-image',
    };

    this.hoverTracker = null;
  }

  connectedCallback() {
    this.optionNodes = this.querySelectorAll(this.selectors.swatches);
    this.init();
  }

  init() {
    this.abortController = new AbortController();

    this.pcard = this.closest(this.selectors.card);
    this.mainImage = this.pcard.querySelector(this.selectors.mainImg);

    this.optionNodes.forEach((button) => {
      button.addEventListener('mouseenter', this.onMouseEnter.bind(this), {
        signal: this.abortController.signal,
      });
    });
  }

  onMouseEnter(e) {
    const { target } = e;
    const variantImage = target.querySelector(this.selectors.variantImg);

    clearTimeout(this.hoverTracker);
    this.hoverTracker = setTimeout(() => {
      this.selected && this.selected.removeAttribute('aria-selected');
      target.setAttribute('aria-selected', true);
      this.selected = target;

      if (this.mainImage && variantImage) {
        this.mainImage.src = variantImage.src;
        this.mainImage.srcset = variantImage.srcset;
      }
    }, 50);
  }

  disconnectedCallback() {
    this.abortController.abort();
  }
}
customElements.define('color-swatch', ColorSwatch, { extends: 'ul' });

class ScrollingPromotion extends HTMLElement {
  constructor() {
    super();
    if (FoxTheme.config.motionReduced) return;
    this.promotion = this.querySelector('.promotion');
    this.repeatTimes = typeof this.dataset.repeats !== 'undefined' ? Number(this.dataset.repeats) : 10;

    FoxTheme.Motion.inView(this, this.init.bind(this), { margin: '200px 0px 200px 0px' });
  }
  init() {
    if (this.childElementCount === 1) {
      this.promotion.classList.add('promotion--animated');

      for (let index = 0; index < this.repeatTimes; index++) {
        this.clone = this.promotion.cloneNode(true);
        this.appendChild(this.clone);
      }

      // Pause when out of view.
      const observer = new IntersectionObserver(
        (entries, _observer) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.scrollingPlay();
            } else {
              this.scrollingPause();
            }
          });
        },
        { rootMargin: '0px 0px 50px 0px' }
      );

      observer.observe(this);
    }
  }

  scrollingPlay() {
    this.classList.remove('scrolling-promotion--paused');
  }

  scrollingPause() {
    this.classList.add('scrolling-promotion--paused');
  }
}
customElements.define('scrolling-promotion', ScrollingPromotion);

class ReadMore extends HTMLElement {
  constructor() {
    super();

    this.selectors = {
      content: '.read-more__content',
      button: '.read-more__toggle',
      buttonText: '.btn__text',
    };

    this.classes = {
      isDisabled: 'is-disabled',
      isCollapsed: 'is-collapsed',
    };

    this.abortController = new AbortController();

    this.toggleClass = this.dataset.toggleClass;
    this.showText = this.dataset.showText;
    this.hideText = this.dataset.hideText;
    this.lineClamp = parseInt(this.dataset.lineClamp);
    this.buttonEl = this.querySelector(this.selectors.button);
    this.contentEl = this.querySelector(this.selectors.content);

    this.buttonEl.addEventListener('click', this.onClick.bind(this), {
      signal: this.abortController.signal,
    });

    this.init();
  }

  init() {
    const lineHeight = parseFloat(window.getComputedStyle(this.contentEl).lineHeight);
    const contentHeight = this.contentEl.scrollHeight;
    const maxHeight = lineHeight * this.lineClamp;

    if (contentHeight <= maxHeight) {
      this.buttonEl.style.display = 'none';
      return;
    }

    this.classList.remove(this.classes.isDisabled);
    this.contentEl.classList.remove(this.toggleClass);
    this.showLess();
  }

  showMore() {
    this.contentEl.classList.remove(this.toggleClass);
    this.classList.remove(this.classes.isCollapsed);
    this.buttonEl.querySelector(this.selectors.buttonText).textContent = this.hideText;
    this.resetHeight();
  }

  showLess() {
    this.contentEl.classList.add(this.toggleClass);
    this.classList.add(this.classes.isCollapsed);
    this.buttonEl.querySelector(this.selectors.buttonText).textContent = this.showText;
    this.setHeight();
  }

  setHeight() {
    const lineHeight = parseFloat(window.getComputedStyle(this.contentEl).lineHeight);
    const lines = parseInt(window.getComputedStyle(this.contentEl).getPropertyValue('--line-clamp'));
    const maxHeight = lineHeight * lines;
    this.contentEl.style.setProperty('max-height', maxHeight + 'px');
  }

  resetHeight() {
    this.contentEl.style.removeProperty('max-height');
  }

  onClick(evt) {
    if (this.contentEl.classList.contains(this.toggleClass)) {
      this.showMore();
    } else {
      this.showLess();
    }
  }

  disconnectedCallback() {
    this.abortController.abort();
  }
}
customElements.define('read-more', ReadMore);

class CopyToClipboard extends HTMLDivElement {
  constructor() {
    super();

    this.classes = {
      copied: 'tooltip--is-visible',
    };
    this.clickHandler = this.onClick.bind(this);
    this.clickTracker = null;
  }

  get button() {
    return this.querySelector('button');
  }

  connectedCallback() {
    this.button.addEventListener('click', this.clickHandler);
  }

  onClick(event) {
    event.preventDefault();
    const valueToCopy = this.dataset.copyValue;

    try {
      navigator.clipboard.writeText(valueToCopy);
      this.classList.add(this.classes.copied);
      clearTimeout(this.clickTracker);
      this.clickTracker = setTimeout(() => {
        this.classList.remove(this.classes.copied);
      }, 3000);
    } catch (error) {}
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.clickHandler);
  }
}
customElements.define('copy-to-clipboard', CopyToClipboard, { extends: 'div' });

class ScrollProgressBar extends HTMLElement {
  constructor() {
    super();
  }

  get totalWidth() {
    return this.contentContainer.offsetWidth;
  }

  get targetId() {
    return this.getAttribute('target');
  }

  get target() {
    return document.getElementById(this.targetId);
  }

  get targetScrollLeft() {
    return this.target.scrollLeft;
  }

  set targetScrollLeft(value) {
    this.target.scrollLeft = value;
  }

  connectedCallback() {
    // Create media query list
    this.mediaQuery = window.matchMedia(FoxTheme.config.mediaQueryMobile);

    // Create ResizeObserver
    this.resizeObserver = new ResizeObserver(() => {
      if (this.mediaQuery.matches) {
        this.init();
      }
    });

    // Store media query handler
    this.mediaQueryHandler = (event) => {
      if (event.matches) {
        this.init();
      } else {
        this.disable();
      }
    };

    // Add media query change listener
    this.mediaQuery.addEventListener('change', this.mediaQueryHandler);

    // Initial check
    if (!this.mediaQuery.matches) {
      this.disable();
      return;
    }

    this.init();
  }

  init() {
    if (!this.target) {
      console.error('Target element not found');
      return;
    }

    this.contentContainer = this.target.children[0];
    this.progressBar = this.querySelector('.progress-bar');

    const targetStyle = window.getComputedStyle(this.target);
    this.targetPadding = parseFloat(targetStyle.paddingLeft) + parseFloat(targetStyle.paddingRight);

    // Start observing target for size changes
    this.resizeObserver.observe(this.target);

    // Check if content overflows
    const viewportWidth = this.target.clientWidth - this.targetPadding;

    if (this.totalWidth <= viewportWidth) {
      this.disable();
      return;
    }

    // Calculate initial progress
    this.calculateInitialProgress();

    // Add scroll listener
    this.scrollHandler = () => {
      requestAnimationFrame(() => this.updateProgress());
    };
    this.target.addEventListener('scroll', this.scrollHandler);

    // Show progress bar and do initial update
    this.style.display = 'block';
    this.updateProgress();
  }

  disable() {
    // Remove scroll listener if exists
    if (this.scrollHandler && this.target) {
      this.target.removeEventListener('scroll', this.scrollHandler);
    }

    // Hide progress bar
    this.style.display = 'none';

    // Reset progress
    if (this.progressBar) {
      this.progressBar.style.width = '0%';
    }

    // Stop observing target
    if (this.target) {
      this.resizeObserver.unobserve(this.target);
    }
  }

  disconnectedCallback() {
    // Clean up media query listener with stored handler
    this.mediaQuery.removeEventListener('change', this.mediaQueryHandler);
    // Disconnect resize observer
    this.resizeObserver.disconnect();
    this.disable();
  }

  calculateInitialProgress() {
    const viewportWidth = this.target.clientWidth - this.targetPadding;
    this.initialProgress = (viewportWidth / this.totalWidth) * 100;

    this.target.addEventListener('scroll', () => {
      requestAnimationFrame(() => this.updateProgress());
    });
    this.updateProgress();
  }

  updateProgress() {
    const factor = FoxTheme.config.isRTL ? -1 : 1;
    const viewportWidth = this.target.clientWidth - this.targetPadding;
    const scrolled = factor * this.targetScrollLeft;
    const maxScroll = this.totalWidth - viewportWidth;

    const scrollProgress = (scrolled / maxScroll) * (100 - this.initialProgress);
    const totalProgress = this.initialProgress + scrollProgress;

    const clampedProgress = Math.min(100, Math.max(this.initialProgress, totalProgress));

    this.progressBar.style.width = `${clampedProgress}%`;
  }
}

customElements.define('scroll-progress-bar', ScrollProgressBar);

class ScrollPagination extends ScrollProgressBar {
  constructor() {
    super();
  }

  get columns() {
    return this.target.querySelectorAll('.swipe-mobile__inner > .f-column:not(.hidden)');
  }

  disable() {
    super.disable();

    this.querySelector('.scroll-pagination__prev').removeEventListener('click', this.handleDecreaseScroll.bind(this));
    this.querySelector('.scroll-pagination__next').removeEventListener('click', this.handleIncreaseScroll.bind(this));
  }

  init() {
    super.init();

    this.columnWidth = this.columns[0].offsetWidth;

    this.querySelector('.scroll-pagination__prev').addEventListener('click', this.handleDecreaseScroll.bind(this));
    this.querySelector('.scroll-pagination__next').addEventListener('click', this.handleIncreaseScroll.bind(this));
  }

  handleDecreaseScroll(e) {
    if (this.targetScrollLeft <= this.columnWidth) {
      e.preventDefault();
      return;
    }

    this.targetScrollLeft -= this.columnWidth;

    window.scrollBy({
      left: this.targetScrollLeft,
      behavior: 'smooth',
    });
  }

  handleIncreaseScroll(e) {
    if (this.targetScrollLeft >= this.totalWidth) {
      e.preventDefault();
      return;
    }

    this.targetScrollLeft += this.columnWidth;

    window.scrollBy({
      left: this.targetScrollLeft,
      behavior: 'smooth',
    });
  }

  updateProgress() {
    const current = Math.round(this.targetScrollLeft / this.columnWidth) + 1;
    this.querySelector('.scroll-pagination__current').innerText = current;
  }
}

customElements.define('scroll-pagination', ScrollPagination);

class MasonryLayout extends HTMLElement {
  constructor() {
    super();
  }

  get gridContainer() {
    return this.querySelector('.f-grid') !== null ? this.querySelector('.f-grid') : this;
  }

  get gridItems() {
    return this.querySelectorAll('.f-column');
  }

  get rowGap() {
    const rowGap = window.getComputedStyle(this.gridContainer).getPropertyValue('--f-row-gap');

    return parseFloat(rowGap.replace('rem', '')) * 10;
  }

  get columnNumber() {
    return window.getComputedStyle(this.gridContainer).getPropertyValue('--f-grid-columns') || 1;
  }

  connectedCallback() {
    this.init();
    // const events = ['matchLaptop','unmatchLaptop','matchTablet','unmatchTablet','matchMobile','unmatchMobile'];
    // events.forEach(event => document.addEventListener(event, this.init.bind(this)));
    window.addEventListener('resize', FoxTheme.utils.debounce(this.init.bind(this), 100), false);
  }

  init() {
    if (FoxTheme.config.mqlMobile) {
      this.disable();
    } else {
      this.calculatePositioning();
    }
  }

  disable() {
    Array.from(this.gridItems).forEach((item) => item.style.removeProperty('--offset-top'));
  }

  calculatePositioning() {
    this.disable();
    if (this.columnNumber <= 1) return;
    Array.from(this.gridItems)
      .slice(this.columnNumber)
      .forEach((col, i) => {
        const prevItem = this.gridItems[i].children[0];
        const currentItem = col.children[0];

        const prevItemPos = prevItem.getBoundingClientRect().bottom;
        const currentItemPos = currentItem.getBoundingClientRect().top;

        const offsetTop = prevItemPos - currentItemPos + this.rowGap;

        col.style.setProperty('--offset-top', `${offsetTop}px`);
      });
  }
}
customElements.define('masonry-layout', MasonryLayout);

if (!customElements.get('show-more')) {
  class ShowMore extends ReadMore {
    constructor() {
      super();
    }

    get buttonWrapper() {
      return this.querySelector('.read-more__btn');
    }

    get originalHeight() {
      return this.contentEl.children[0].offsetHeight;
    }

    get swipeMobile() {
      return this.dataset.swipeMobile === 'true';
    }

    get disableOnMobile() {
      return this.dataset.disableOnMobile === 'true';
    }

    connectedCallback() {
      const events = ['matchMobile', 'unmatchMobile', 'matchTablet', 'unmatchTablet', 'matchLaptop', 'unmatchLaptop'];

      events.forEach((event) => document.addEventListener(event, this.init.bind(this)));
    }

    init() {
      this.maxHeight = parseInt(this.dataset.maxHeight);

      if (FoxTheme.config.mqlMobile && this.dataset.maxHeightMobile) {
        this.maxHeight = parseInt(this.dataset.maxHeightMobile);
      }

      this.buttonWrapper.classList.toggle('!hidden', this.originalHeight <= this.maxHeight);

      if (this.disable()) {
        this.showMore();
        return;
      }

      super.init();
    }

    setHeight() {
      this.contentEl.style.setProperty('--max-height', this.maxHeight + 'px');
    }

    resetHeight() {
      this.contentEl.style.removeProperty('--max-height');
    }

    disable() {
      return (
        (FoxTheme.config.mqlMobile && this.disableOnMobile) ||
        this.maxHeight <= 0 ||
        this.originalHeight <= this.maxHeight
      );
    }
  }
  customElements.define('show-more', ShowMore);
}

class HighlightText extends HTMLElement {
  constructor() {
    super();
    FoxTheme.Motion.inView(this, this.init.bind(this));
  }
  init() {
    this.classList.add('animate');
  }
}
customElements.define('highlight-text', HighlightText, { extends: 'em' });

customElements.define(
  'swipe-wrapper',
  class SwipeWrapper extends HTMLDivElement {
    constructor() {
      super();

      this.swipeEl = null;
      this.resizeObserver = null;
      this.scrollHandler = this.updateScrollClasses.bind(this);
      this.classes = {
        active: 'swipe--active',
        begin: 'swipe--begin',
        end: 'swipe--end',
      };
    }

    connectedCallback() {
      this.swipeEl = this.querySelector('.swipe__element');
      if (!this.swipeEl) return;

      this.init();

      this.swipeEl.addEventListener('scroll', this.scrollHandler);
      if (this.swipeEl.offsetParent !== null) {
        this.updateScrollClasses();
      }

      this.resizeObserver = new ResizeObserver(() => {
        // Check if element is visible and measurable
        if (this.swipeEl.offsetParent !== null) {
          this.updateScrollClasses();
        }
      });
      this.resizeObserver.observe(this.swipeEl);
    }

    disconnectCallback() {
      if (this.swipeEl) {
        this.swipeEl.removeEventListener('scroll', this.scrollHandler);
      }
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      }
    }

    init() {
      if (this.swipeEl.classList.contains('swipe-all')) {
        this.setActive(true);
        return;
      }

      const swipeMobile = this.swipeEl.classList.contains('swipe-mobile');
      if (swipeMobile) {
        const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
        const update = () => {
          this.setActive(mql.matches);
        };
        update();
        mql.addEventListener('change', update);
      }

      const swipeTablet = this.swipeEl.classList.contains('swipe-tablet');
      if (swipeTablet) {
        const mql = window.matchMedia(FoxTheme.config.mediaQueryTablet);
        const update = () => {
          this.setActive(mql.matches);
        };
        update();
        mql.addEventListener('change', update);
      }
    }

    setActive(isActive = true) {
      this.classList.toggle(this.classes.active, isActive);
    }

    updateScrollClasses() {
      const scrollLeft = this.swipeEl.scrollLeft;
      const clientWidth = this.swipeEl.clientWidth;
      const scrollWidth = this.swipeEl.scrollWidth;

      const atStart = scrollLeft <= 0;
      const atEnd = Math.ceil(scrollLeft + clientWidth) >= scrollWidth;

      this.classList.toggle(this.classes.begin, atStart);
      this.classList.toggle(this.classes.end, atEnd);
    }
  },
  { extends: 'div' }
);
